import { Add, ClearRounded, Delete, Save } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import Search from '@mui/icons-material/Search';
import {
    Autocomplete,
    Badge,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Skeleton,
    Stack,
    styled,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    tooltipClasses,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { default as React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import CommonDialog from '../../common/CommonDialog';
import ControlledAutocomplete from '../../common/ControlledAutocomplete';
import {
    MuiAutocompleteWithFocus,
    MuiDisabledAutocomplete,
    MuiDisabledRadioGroup,
    MuiDisabledTextField,
    MuiTextFieldWithFocus,
} from '../../config/MaterialUIConstants';
import SuccessMessageModal from '../../container/Common/SuccessMessage';
import { configDetails } from '../../redux/Account/action';
import { getDefaultShopPrice } from '../../redux/Account/ShopDetails/action';
import {
    addInventoryApi,
    addPartsApi,
    addPartsBrandApi,
    addPartsCategoryApi,
    addTyreModalApi,
    checkInventoryBeforeApi,
    getInventoryBatchDetailApi,
    getInventoryFilterRecord,
    getInventoryListApi,
    getNextPartSequenceApi,
    getPartsBrandListApi,
    getPartsCategoryListApi,
    getPartsListApi,
    getSupplierInvoiceList,
    getTyreModalListApi,
    updateInventoryApi,
} from '../../redux/Inventory/action';
import { getInvoiceFeesListApi } from '../../redux/Invoice/action';
import { getSupplierListApi } from '../../redux/Supplier/action';
import { businessInventoryKeys } from '../../services/business/inventory';
import { INVENTORY_TYPES, INVETORY_CASE, PART_TYPES, PARTS_PROVIDER, PARTS_STATUS, PRICING_METHOD, TableRowsLoader } from '../../utility/Constant';
import {
    filterUndefined,
    formatTireDimensionWithCursor,
    handlePreventKeyDownDecimal,
    truncateToFixed,
    updateObjectAtIndex,
} from '../../utility/helpers/commonFunction';
import { formatCurrency } from '../../utility/helpers/displayHelper';
import { NumericEngine } from '../../utility/helpers/numericEngine';
import BrandSvg from '../../utility/Svg/BrandSvg';
import SupplierIconSvg from '../../utility/Svg/SupplierIconSvg';
import useDebounce from '../../utility/useDebounce';
import InputWithIcon from '../Common/InputWithIcon';
import AddQuickSupplierModal from '../Suppliers/AddQuickSupplierModal';
import PartUsedInvoiceModal from '../Suppliers/SupplierInvoice/PartUsedInvoiceModal';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: '2px solid ',
    boxShadow: 24,
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -12],
                        },
                    },
                ],
            },
        }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(97, 97, 97, 0.90)',
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.08)',
        color: '#fff',
        width: 250,
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '-0.42px',
        padding: '12px',
        lineHeight: '120%',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',

        gap: '0',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(97, 97, 97, 0.90)', // Same as tooltip background color
    },
}));

const AddInventoryModal = ({
    isAddPartBtn,
    isAddPartAgain,
    setIsAddPartAgain,
    disabledFields = [],
    showUsedInInvoiceFeild = false,
    FeildLabelName = 'Used In Invoices',
    stockPlusMinus = 0,
    isUsedInvoiceQty = null,
    setIsUsedInvoiceQty,
    addQty = false,
    isUseLastCost = false,
    conflictResolutionProp = null,
    type = INVENTORY_TYPES.INVENTORY,
    supplierId = null,
    supplierInvoiceNumber = null,
    supplierInvoiceQty = null,
    supplierInvoiceCost = null,
    partType = PART_TYPES.PARTS,
    inventoryId = null,
    batchNumber = null,
    openModal,
    closeModal,
    onSubmitModal,
    setShowLoader,
    showLoader,
    fetchApi,
    viewOnly = false,
    ShowAllTabs = true,
    ShowTabIndex = 0,
    modalType = 'add',
    selectedInventory,
    setSelectedInventory,
    selectedInventoryIndex,
    showEditInListing = true,
}) => {
    console.log('disabledFields', disabledFields);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dialogContentRef = useRef(null);
    const qtyInputRef = useRef(null);
    const queryClient = useQueryClient();

    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('lg'));

    useEffect(() => {
        if (qtyInputRef.current && addQty) {
            qtyInputRef.current.focus();
        }
    }, [addQty, qtyInputRef.current]);
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        getValues,
        setError,
        watch,
        clearErrors,
    } = useForm({
        defaultValues: {
            qty: 1,
            cost: 0,
            pricingMethod: 'margin',
            markupPercentage: 0,
            marginPercentage: 0,
            markupOrMarginPercentage: 0,
            retailPrice: 0,
            profitPerUnit: 0,
            totalRetailPrice: 0,
            totalProfit: 0,
            feeAmount: 0,
            totalFee: 0,
            totalAfterFee: 0,
            sold: 0,
        },
    });
    const [caretPosition, setCaretPosition] = useState(0);
    const [singleInventoryId, setSingleInventoryId] = useState(null);
    const [editModalTabvalue, setEditModalTabValue] = useState(ShowTabIndex);
    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');
    const [editableRows, setEditableRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [partInvoiceModal, setPartInvoiceModal] = useState(false);
    const [autoGenratePartNumber, setAutoGeneratePartNumber] = useState(null);
    //
    const [openAddSupplierModal, setOpenAddSupplierModal] = useState(false);

    //
    const [order, setOrder] = useState('ASC');

    const [isUsedInCustomerInvoice, setIsUsedInCustomerInvoice] = useState(false);
    const [partExistLoader, setPartExistLoader] = useState(false);
    const [inventoryCase, setInventoryCase] = useState(INVETORY_CASE.CASE_2);
    const [openConflictModal, setOpenConflictModal] = useState(false);
    const [inventoryLoader, setInventoryLoader] = useState(false);
    const [updateInventoryLoader, setUdateInventoryLoader] = useState(false);
    const [partCategoryId, setPartCategoryId] = useState(undefined);
    const [inventorySearch, setInventroySearch] = useState('');
    const [inventoryStatus, setInventoryStatus] = useState(false);
    const [partsProvider, setPartsProvider] = useState('');
    const [togglePartType, setTogglePartType] = useState(partType);
    const debouncedInventorySearch = useDebounce(inventorySearch, 500);

    //for parts type
    const [selectedPartsId, setSelectedPartsId] = useState(undefined);
    const [supplierInvoiceId, setSupplierInvoiceId] = useState(null);
    //for tire types

    const [supplierInput, setSupplierInput] = useState('');
    const [supplierName, setSupplierName] = useState('');

    const [loading, setLoading] = useState(false);

    const supplierList = useSelector((state) => state?.supplier?.supplierData?.data) || [];
    const inventoryList = useSelector((state) => state?.inventory?.inventoryList?.data);
    const supplierInvoice = useSelector((state) => state?.inventory?.supplierInvoiceAray?.data);

    //supplierInvoice API
    const [alreadyExistSupplierData, setAlreadyExistSupplierData] = useState(null);
    const [supplierInvoiceList, setSupplierInvoiceList] = useState([]);
    const [invoiceInput, setInvoiceInput] = useState('');
    const debounceInvoiceSearch = useDebounce(invoiceInput, 500);
    const [supplierInvoiceLoading, setSupplierInvoiceLoading] = useState({
        fetch: false,
        save: false,
    });
    const watchPartName = watch('partName');
    const debouncedTyreDimension = useDebounce(watch('tyreDimension'), 500);
    const debouncedPartNumber = useDebounce(watch('partNumber'), 500);
    const watchSupplierId = watch('supplierId');

    const shopConfigData = useSelector((state) => state.account.configDetailData);
    const defaultPriceMethod = shopConfigData?.priceBase?.inventory?.defaultPricingMethod ?? PRICING_METHOD.MARGIN;
    const priceTypes = [PRICING_METHOD.MARGIN, PRICING_METHOD.RETAIL_PRICE, PRICING_METHOD.MARKUP];

    useEffect(() => {
        if (debouncedPartNumber || debouncedTyreDimension) {
            fetchFilterRecord(debouncedPartNumber, debouncedTyreDimension || '', watchPartName || '');
        }
    }, [debouncedTyreDimension, debouncedPartNumber]);

    const orderedPriceTypes = useMemo(() => {
        if (!defaultPriceMethod) return priceTypes;

        if (defaultPriceMethod === PRICING_METHOD.RETAIL_PRICE) {
            return [PRICING_METHOD.RETAIL_PRICE, PRICING_METHOD.MARGIN, PRICING_METHOD.MARKUP];
        }

        return [defaultPriceMethod, PRICING_METHOD.RETAIL_PRICE, priceTypes.find((t) => t !== defaultPriceMethod && t !== PRICING_METHOD.RETAIL_PRICE)];
    }, [shopConfigData?.priceBase, shopConfigData?.priceBase?.inventory, defaultPriceMethod]);

    const fetchFilterRecord = async (partNumber, tyreDimension, partName) => {
        try {
            let params = { partName: partName };

            if (togglePartType === PART_TYPES.TYRE) {
                params.tyreDimension = tyreDimension;
            } else {
                params.partNumber = partNumber;
            }
            const resp = await dispatch(getInventoryFilterRecord(params));

            if (resp?.data?._id) {
                setTogglePartType(resp?.data?.partsType || PART_TYPES.PARTS);
                setValue('partName', resp?.data?.part?.partName);
                setPartsInput(resp?.data?.part?.partName);

                setSelectedPartsId(resp?.part?._id);

                setValue('description', resp?.data?.lastDescription);

                if (resp?.data?.partsCategory?.name) {
                    setValue('partsCategory', resp?.data?.partsCategory?.name);
                    setCategoryInput(resp?.data?.partsCategory?.name);
                    setIsAdditionalVisible(true);
                }

                if (resp?.data?.partsBrand?.name) {
                    setValue('partsBrand', resp?.data?.partsBrand?.name);
                    setBrandInput(resp?.data?.partsBrand?.name);
                    setIsAdditionalVisible(true);
                }

                if (resp?.data?.tyreModel?.tyreModelName) {
                    setValue('tyreModelId', resp?.data?.tyreModel?.tyreModelName);
                    setTireModalInput(resp?.data?.tyreModelName);
                    setIsAdditionalVisible(true);
                }

                if (resp?.data?.lastPartsProvider) {
                    setValue('partsProvider', resp?.data?.lastPartsProvider);
                    setPartsProvider(resp?.data?.lastPartsProvider);
                    setIsAdditionalVisible(true);
                }

                if (!supplierId && resp?.data?.supplier?._id) {
                    setValue('supplierId', resp?.data?.supplier?._id);
                    setSupplierInput(resp?.data?.supplier?.name);
                }
                if (resp.data?.supplierInvoice?.length > 0) {
                    setSupplierInvoiceId(resp?.data?.supplierInvoice[0]?._id);
                }

                let finalQty = 1;
                let finalCost = resp?.data?.lastCost || 0;
                let finalRetailPrice = resp?.data?.lastRetailPrice || 0;
                let finalMarginPercentage = resp?.data?.lastMarginPercentage || 0;
                let finalMarkupPercentage = resp?.data?.lastMarkupPercentage || 0;
                let finalFee = resp?.data?.lastFee || 0;

                setValue('cost', resp.data.lastCost);

                const pricingMethod = resp.data.lastPricingMethod;

                setValue('pricingMethod', pricingMethod);

                if (resp?.data?.fee?.name) {
                    setValue('feeName', resp?.data?.fee?.name);
                    setValue('feeAmount', resp?.data?.feeAmount);
                    setIsFeeVisible(true);
                }

                // Use effective quantity for calculations when opened from invoice
                const effectiveQtyForSupplier =
                    showUsedInInvoiceFeild && type === INVENTORY_TYPES.INVOICE && isUsedInvoiceQty !== null && isUsedInvoiceQty !== undefined
                        ? Number(isUsedInvoiceQty || 0)
                        : finalQty;

                if (pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                    calculateRetailPriceChange(finalRetailPrice, effectiveQtyForSupplier, finalCost, finalFee);
                }

                if (pricingMethod === PRICING_METHOD.MARGIN) {
                    calculateMarginChange(finalMarginPercentage, effectiveQtyForSupplier, finalCost, finalFee);
                }

                if (pricingMethod === PRICING_METHOD.MARKUP) {
                    calculateMarkupChange(finalMarkupPercentage, effectiveQtyForSupplier, finalCost, finalFee);
                }
            } else if (!batchNumber && !inventoryId) {
                // if (!getValues().partName) {
                setValue('partName', '');
                setPartsInput('');
                // }

                // if (!supplierInvoiceNumber) {
                //     setValue('supplierInvoiceNumber', '');
                // }

                setSelectedPartsId('');
                setInvoiceInput('');
                setValue('description', '');

                setValue('partsCategory', '');
                setCategoryInput('');

                setValue('partsBrand', '');
                setBrandInput('');

                setValue('tyreModelId', '');
                setTireModalInput('');

                setValue('partsProvider', '');
                setPartsProvider('');

                if (!supplierId) {
                    setValue('supplierId', '');
                    setSupplierInput('');
                }

                setSupplierInvoiceId('');

                setValue('cost', 0);
                setValue('feeName', '');
                setfeeInput('');
                setValue('feeAmount', 0);
                setIsFeeVisible(false);
                fetchDefaultShopPrice();
            }
        } catch (error) {
            // setSupplierInvoiceList([]);
        }
    };

    useEffect(() => {
        if (watchSupplierId) {
            fetchSupplierInvoiceList(debounceInvoiceSearch, watchPartName, debouncedPartNumber, watchSupplierId);
        }
    }, [debounceInvoiceSearch, watchPartName, debouncedPartNumber, watchSupplierId]);

    const fetchSupplierInvoiceList = async (searchTerm, partName, partNumber, supplier) => {
        try {
            setSupplierInvoiceLoading({ ...supplierInvoiceLoading, fetch: true });
            const params = {
                search: searchTerm,
            };
            if (partNumber) {
                params.partNumber = partNumber;
            }
            if (partName) {
                params.partName = partName;
            }
            if (supplier) {
                params.supplier = supplier;
            }

            const resp = await dispatch(getSupplierInvoiceList(params));
            if (resp.data?.length > 0) {
                setSupplierInvoiceList(resp.data);
                if (getValues().supplierInvoiceNumber) {
                    const findResp = resp.data.find((item) => item.invoiceNumber === getValues().supplierInvoiceNumber);
                    if (findResp) {
                        setValue('sold', findResp?.sold || 0);
                        setIsUsedInCustomerInvoice(findResp?.isUsedInCustomerInvoice || false);
                    }
                }
            } else {
                setSupplierInvoiceList([]);
            }
        } catch (error) {
            setSupplierInvoiceList([]);
            console.error('Error fetching supplier invoice:', error);
        } finally {
            setSupplierInvoiceLoading({ ...supplierInvoiceLoading, fetch: false });
        }
    };

    const handleCreateNewSupplierInvoice = (field) => {
        // Close dropdown and select new item
        setTimeout(() => {
            const autocompleteInput = document.getElementById('invoice-number-autocomplete');
            if (autocompleteInput) {
                autocompleteInput.blur();
                autocompleteInput.focus();
            }

            const newInvoice = {
                _id: `temp-${Date.now()}`, // Unique temporary ID
                invoiceNumber: invoiceInput.trim(),
            };

            // Set the value in the form
            field.onChange(newInvoice.invoiceNumber);
        }, 300);
    };

    //part modal hooks
    const [partsInput, setPartsInput] = useState('');
    const [partsModalLoading, setPartsModalLoading] = useState({
        fetch: false,
        save: false,
    });
    const partsList = useSelector((state) => state?.inventory?.partsList?.data) || [];

    const handleSaveNewPartName = async (newOption) => {
        try {
            setPartsModalLoading({ ...partsModalLoading, save: true });
            const response = await addPartsApi({
                partName: newOption.trim(),
                partsType: togglePartType,
            });

            if (response) {
                // Fetch updated list
                await fetchPartsApi('');

                // Update form value
                setValue('partName', response?.data?._id);
                clearErrors('partName');
                // Show success modal
                setOpenSuccessModal(true);
                setSuccessMessage(response?.message);

                // Close dropdown and select new item
                const autocompleteInput = document.getElementById('part-autocomplete');
                if (autocompleteInput) {
                    autocompleteInput.blur();
                    autocompleteInput.focus();
                }
            }
        } catch (error) {
            console.error('Error saving new tire model:', error);
            // Handle error (show error toast/message)
        } finally {
            setPartsModalLoading({ ...partsModalLoading, save: false });
        }
    };
    const fetchPartsApi = async (searchTerm) => {
        try {
            setPartsModalLoading({ ...partsModalLoading, fetch: true });
            await dispatch(getPartsListApi({ partsType: togglePartType }));
        } catch (error) {
            console.error('Error fetching tire models:', error);
            // Handle error (show error toast/message)
        } finally {
            setPartsModalLoading({ ...partsModalLoading, fetch: false });
        }
    };
    const handleKeyDownPart = (event, field) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();

            const highlightedOption = document.querySelector('li.MuiAutocomplete-option.Mui-focused');
            const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();

            const inputLowerCase = partsInput.trim().toLowerCase();
            const filteredOptions = partsList.filter((option) => option.partName.toLowerCase().includes(optionText || inputLowerCase));
            const exactMatch = partsList.find((option) => option.partName.toLowerCase() === (optionText || inputLowerCase));

            if (exactMatch) {
                // If there's an exact match, select it
                setTimeout(() => {
                    setValue('partName', exactMatch._id);
                }, [200]);
                setPartsInput(exactMatch.partName);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            } else if (inputLowerCase) {
                // If no exact match and input is not empty, open modal to save new category
                handleSaveNewPartName(partsInput);
            } else if (filteredOptions.length > 0) {
                // If input is empty, select the first filtered option
                const firstOption = filteredOptions[0];
                field.onChange(firstOption._id);
                setPartsInput(firstOption.partName);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            }
        }
    };

    //category modal hooks
    const [categoryInput, setCategoryInput] = useState('');
    const [categoryModalLoading, setCategoryModalLoading] = useState({
        fetch: false,
        save: false,
    });
    const partsCategoryList = useSelector((state) => state?.inventory?.partsCategoryList?.data) || [];

    const handleSaveNewPartsCategory = async (newOption) => {
        try {
            setCategoryModalLoading({ ...categoryModalLoading, save: true });
            const response = await addPartsCategoryApi({ name: newOption.trim() });

            if (response) {
                // Fetch updated list
                await fetchPartsCategoryApi('');

                // Update form value
                setValue('partsCategory', response?.data?._id);

                // Show success modal
                setOpenSuccessModal(true);
                setSuccessMessage(response?.message);

                // Close dropdown and select new item
                const autocompleteInput = document.getElementById('category-autocomplete');
                if (autocompleteInput) {
                    autocompleteInput.blur();
                    autocompleteInput.focus();
                }
            }
        } catch (error) {
            console.error('Error saving new tire model:', error);
            // Handle error (show error toast/message)
        } finally {
            setCategoryModalLoading({ ...categoryModalLoading, save: false });
        }
    };
    const fetchPartsCategoryApi = async (searchTerm) => {
        try {
            setCategoryModalLoading({ ...categoryModalLoading, fetch: true });
            await dispatch(getPartsCategoryListApi({}));
        } catch (error) {
            console.error('Error fetching tire models:', error);
            // Handle error (show error toast/message)
        } finally {
            setCategoryModalLoading({ ...categoryModalLoading, fetch: false });
        }
    };
    const handleKeyDownCategory = (event, field) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const highlightedOption = document.querySelector('li.MuiAutocomplete-option.Mui-focused');
            const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();

            const inputLowerCase = categoryInput.trim().toLowerCase();

            const filteredOptions = partsCategoryList.filter((option) => option.name.toLowerCase().includes(optionText || inputLowerCase));

            const exactMatch = partsCategoryList.find((option) => option.name.toLowerCase() === (optionText || inputLowerCase));

            if (exactMatch) {
                // If there's an exact match, select it
                field.onChange(exactMatch._id);
                setCategoryInput(exactMatch.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            } else if (inputLowerCase) {
                // If no exact match and input is not empty, open modal to save new category
                handleSaveNewPartsCategory(categoryInput);
            } else if (filteredOptions.length > 0) {
                // If input is empty, select the first filtered option
                const firstOption = filteredOptions[0];
                field.onChange(firstOption._id);
                setCategoryInput(firstOption.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            }
        }
    };

    //tyre model hooks
    const [tireModalInput, setTireModalInput] = useState('');
    const [tireModalLoading, setTireModalLoading] = useState({
        fetch: false,
        save: false,
    });
    const tyreModalList = useSelector((state) => state?.inventory?.tyreModalList?.data) || [];

    const handleSaveNewTireModal = async (newOption) => {
        try {
            setTireModalLoading({ ...tireModalLoading, save: true });
            const response = await addTyreModalApi({ name: newOption.trim() });

            if (response) {
                // Fetch updated list
                await fetchTireModalApi('');

                // Update form value
                setValue('tyreModelId', response?.data?._id);

                // Show success modal
                setOpenSuccessModal(true);
                setSuccessMessage(response?.message);

                // Close dropdown and select new item
                const autocompleteInput = document.getElementById('model-autocomplete');
                if (autocompleteInput) {
                    autocompleteInput.blur();
                    autocompleteInput.focus();
                }
            }
        } catch (error) {
            console.error('Error saving new tire model:', error);
            // Handle error (show error toast/message)
        } finally {
            setTireModalLoading({ ...tireModalLoading, save: false });
        }
    };

    const fetchTireModalApi = async (searchTerm) => {
        try {
            setTireModalLoading({ ...tireModalLoading, fetch: true });
            await dispatch(getTyreModalListApi({ searchTerm }));
        } catch (error) {
            console.error('Error fetching tire models:', error);
            // Handle error (show error toast/message)
        } finally {
            setTireModalLoading({ ...tireModalLoading, fetch: false });
        }
    };

    const handleKeyDownTire = (event, field) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();

            const highlightedOption = document.querySelector('li.MuiAutocomplete-option.Mui-focused');
            const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();

            const inputLowerCase = tireModalInput.trim().toLowerCase();

            const filteredOptions = tyreModalList.filter((option) => option.name.toLowerCase().includes(optionText || inputLowerCase));

            const exactMatch = tyreModalList.find((option) => option.name.toLowerCase() === (optionText || inputLowerCase));

            if (exactMatch) {
                // If there's an exact match, select it
                setTimeout(() => {
                    setValue('tyreModelId', exactMatch._id);
                }, [200]);
                setTireModalInput(exactMatch.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            } else if (inputLowerCase) {
                // If no exact match and input is not empty, open modal to save new category
                handleSaveNewTireModal(tireModalInput);
            } else if (filteredOptions.length > 0) {
                // If input is empty, select the first filtered option
                const firstOption = filteredOptions[0];
                field.onChange(firstOption._id);
                setTireModalInput(firstOption.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            }
        }
    };

    //brand model hooks
    const [brandInput, setBrandInput] = useState('');
    const [brandModalLoading, setBrandModalLoading] = useState({
        fetch: false,
        save: false,
    });
    const partsBrandList = useSelector((state) => state?.inventory?.partsBrandList?.data) || [];

    const handleSaveNewPartsBrand = async (newOption) => {
        try {
            setBrandModalLoading({ ...brandModalLoading, save: true });
            const response = await addPartsBrandApi({
                name: newOption.trim(),
                partsType: togglePartType,
            });
            if (response) {
                // Fetch updated list
                await fetchPartsBrandApi('');
                // Update form value
                setValue('partsBrand', response?.data?._id);
                // Show success modal
                setOpenSuccessModal(true);
                setSuccessMessage(response?.message);
                // Close dropdown and select new item
                const autocompleteInput = document.getElementById('brand-autocomplete');
                if (autocompleteInput) {
                    autocompleteInput.blur();
                    autocompleteInput.focus();
                }
            }
        } catch (error) {
            console.error('Error saving new tire model:', error);
            // Handle error (show error toast/message)
        } finally {
            setBrandModalLoading({ ...brandModalLoading, save: false });
        }
    };
    const fetchPartsBrandApi = async (searchTerm) => {
        try {
            setBrandModalLoading({ ...brandModalLoading, fetch: true });
            await dispatch(getPartsBrandListApi({ partsType: togglePartType }));
        } catch (error) {
            console.error('Error fetching tire models:', error);
            // Handle error (show error toast/message)
        } finally {
            setBrandModalLoading({ ...brandModalLoading, fetch: false });
        }
    };

    const handleKeyDownBrand = (event, field) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();

            const highlightedOption = document.querySelector('li.MuiAutocomplete-option.Mui-focused');
            const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();

            const inputLowerCase = brandInput.trim().toLowerCase();

            const filteredOptions = partsBrandList.filter((option) => option.name.toLowerCase().includes(optionText || inputLowerCase));

            const exactMatch = partsBrandList.find((option) => option.name.toLowerCase() === (optionText || inputLowerCase));

            if (exactMatch) {
                // If there's an exact match, select it
                field.onChange(exactMatch._id);
                setBrandInput(exactMatch.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            } else if (inputLowerCase) {
                // If no exact match and input is not empty, open modal to save new category
                handleSaveNewPartsBrand(brandInput);
            } else if (filteredOptions.length > 0) {
                // If input is empty, select the first filtered option
                const firstOption = filteredOptions[0];
                field.onChange(firstOption._id);
                setBrandInput(firstOption.name);

                // Close dropdown after selection
                // setTimeout(() => document.activeElement.blur(), 0);
            }
        }
    };

    useEffect(() => {
        if (openModal && type === INVENTORY_TYPES.SUPPLIER_INVOICE) {
            if (supplierId) {
                setValue('supplierId', supplierId);
            }
            if (supplierInvoiceNumber) {
                setValue('supplierInvoiceNumber', supplierInvoiceNumber);
                setInvoiceInput(supplierInvoiceNumber);
            }
        }
        if (openModal && type === INVENTORY_TYPES.SUPPLIER) {
            if (supplierId) {
                setValue('supplierId', supplierId);
            }
        }
    }, [supplierId, type, supplierInvoiceNumber, openModal]);

    useEffect(() => {
        setEditModalTabValue(ShowTabIndex);
    }, [ShowTabIndex]);

    useEffect(() => {
        setTogglePartType(partType);
    }, [partType]);

    useEffect(() => {
        if ((ShowAllTabs || (!ShowAllTabs && ShowTabIndex === 1)) && openModal) {
            if (debouncedInventorySearch) {
                fetchInventoryList(debouncedInventorySearch);
            } else {
                fetchInventoryList('');
            }
        }
    }, [openModal, debouncedInventorySearch, partCategoryId, inventoryStatus, order]);

    const fetchInventoryList = async (searchValue) => {
        setInventoryLoader(true);
        let params = {
            search: searchValue,
            partsCategory: partCategoryId ? partCategoryId : '',
            stockLastPurchasedDate: order,
            pagination: false,
        };
        if (inventoryStatus) {
            params.partsStatus = PARTS_STATUS.IN_STOCK;
        }
        await dispatch(getInventoryListApi(params));
        setInventoryLoader(false);
    };

    useEffect(() => {
        fetchPartsApi('');
        fetchPartsBrandApi('');
        if (!batchNumber && conflictResolutionProp !== 'create_new_part' && togglePartType === PART_TYPES.PARTS) {
            if (autoGeneratePartNumberFlag) {
                setValue('partNumber', autoGenratePartNumber);
            } else {
                fetchConfig();
            }
        }
    }, [togglePartType]);

    const fetchDefaultShopPrice = async () => {
        const resp = await dispatch(getDefaultShopPrice());

        if (resp) {
            const pricingMethod = resp?.priceBase?.inventory?.defaultPricingMethod || PRICING_METHOD.MARGIN;
            setValue('pricingMethod', pricingMethod);

            if (pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                setValue('retailPrice', 0);
            }

            if (pricingMethod === PRICING_METHOD.MARGIN) {
                setValue('marginPercentage', resp?.priceBase?.inventory?.defaultMargin);
            }

            if (pricingMethod === PRICING_METHOD.MARKUP) {
                setValue('markupPercentage', resp?.priceBase?.inventory?.defaultMarkup);
            }
        }
    };
    const fetchConfig = async () => {
        const resp = await dispatch(configDetails());
        if (resp?.config?.inventory?.part?.autoGeneratePartNumber && conflictResolutionProp !== 'create_new_part' && !batchNumber) {
            const resp = await dispatch(getNextPartSequenceApi());
            setAutoGeneratePartNumber(resp?.data?.partNumber);
            setValue('partNumber', resp?.data?.partNumber);
        } else if (conflictResolutionProp !== 'create_new_part' && !batchNumber) {
            setValue('partNumber', null);
            setAutoGeneratePartNumber(null);
        }
    };

    const autoGeneratePartNumberFlag = shopConfigData?.inventory?.part?.autoGeneratePartNumber;

    useEffect(() => {
        if (openModal) {
            fetchSupplierList('');
            fetchPartsCategoryApi('');
            fetchTireModalApi('');
        }
    }, [openModal]);

    // Debounced fetch function

    // Effect to trigger API fetch

    const fetchSupplierList = async (searchTerm) => {
        await dispatch(
            getSupplierListApi({
                pagination: false,
                sortBy: 'supplierName',
                sortType: 'ASC',
            })
        );
    };

    const handleChangeEditCustomerTabValue = (event, newValue) => {
        setInventroySearch('');
        setPartCategoryId(undefined);
        setEditModalTabValue(newValue);
    };

    const handleCheckboxChange = (item) => {
        if (type === INVENTORY_TYPES.SAVED_SERVICE) {
            item.partQty = 1;
        }
        setSelectedInventory((prev) => {
            const exists = prev.find((selectedItem) => selectedItem?._id === item._id);
            if (exists) {
                return prev.filter((selectedItem) => selectedItem?._id !== item._id);
            }
            return [...prev, item];
        });
    };

    const handleInputChange = (_id, field, value) => {
        setRows((prevRows) => prevRows.map((row) => (row._id === _id ? { ...row, [field]: value } : row)));
        setSelectedInventory((prevRows) => prevRows.map((row) => (row._id === _id ? { ...row, [field]: value } : row)));
    };

    const onSubmit = async (values, dontCheck, conflictResolution) => {
        try {
            setShowLoader(true);
            if (values.supplierId) {
                if (!values.supplierInvoiceNumber && !invoiceInput) {
                    setError('supplierInvoiceNumber', {
                        type: 'manual',
                        message: 'Suppplier invoice number is required.',
                    });
                    return;
                } else {
                    clearErrors('supplierInvoiceNumber');
                }
            }

            const inventoryPayload = {
                partsType: togglePartType,
                partName: values?.partName || selectedPartsId,
                partsBrandName: values?.partsBrand || undefined,
                partsCategoryName: values?.partsCategory || undefined,
                partsProvider: values?.partsProvider || undefined,
                supplierId: values?.supplierId || undefined,
                supplierInvoiceNumber: values?.supplierId ? values.supplierInvoiceNumber || invoiceInput || undefined : undefined,
                partNumber: values.partNumber || undefined,
                description: values?.description || undefined,
                qty: (Number(values.qty) - Number(stockPlusMinus)).toString() || '0',
                cost: Number(values.cost) || 0,

                pricingMethod: values?.pricingMethod,
                retailPrice: values?.retailPrice,
                marginPercentage: Number(values?.marginPercentage) || 0,
                markupPercentage: Number(values?.markupPercentage) || 0,
                // markupOrMarginPercentage: Number(values?.markupOrMarginPercentage) || 0,
                feeName: isFeeVisible ? values?.feeName || undefined : undefined,
                feeAmount: isFeeVisible ? Number(values?.feeAmount) || 0 : undefined,
            };

            // Clean up payload
            if (values.supplierInvoiceNumber === '') {
                inventoryPayload.supplierInvoiceNumber = undefined;
            }

            if (togglePartType === PART_TYPES.TYRE) {
                inventoryPayload.partNumber = undefined;
                inventoryPayload.partsCategoryName = undefined;
                inventoryPayload.tyreModelName = values.tyreModelId || undefined;
                inventoryPayload.tyreDimension = values.tyreDimension || undefined;
            }
            // Special handling for invoice type
            if (type === INVENTORY_TYPES.INVOICE && ShowAllTabs && editModalTabvalue === 1) {
                handleClose();
                onSubmitModal(null, true);
            }

            let check;
            if (conflictResolutionProp === 'update_existing_part') {
                //dont chall the API
            } else if (dontCheck !== true) {
                inventoryPayload.inventoryId = inventoryId || singleInventoryId;
                inventoryPayload.batchNumber = batchNumber;
                check = await checkInventoryBeforeApi(filterUndefined(inventoryPayload));
            }
            if (check?.conflict === true) {
                if (inventoryPayload.supplierId && inventoryPayload.supplierInvoiceNumber) {
                    setInventoryCase(INVETORY_CASE.CASE_2);
                } else {
                    setInventoryCase(INVETORY_CASE.CASE_1);
                }
                setShowLoader(false);
                setOpenConflictModal(true);
                return;
            } else {
            }

            // API call - update or add
            let response;
            if (conflictResolutionProp === 'create_new_part') {
                if (inventoryPayload.inventoryId) {
                    delete inventoryPayload.inventoryId;
                }
                if (inventoryPayload.batchNumber) {
                    delete inventoryPayload.batchNumber;
                }
                // inventoryPayload.conflictResolution = conflictResolution || conflictResolutionProp;
                response = await addInventoryApi(filterUndefined(inventoryPayload));

                if (type === INVENTORY_TYPES.SAVED_SERVICE && response.status) {
                    const cloneObj = { ...response.data };
                    cloneObj.partQty = 1;
                    const cloneInventory = [...selectedInventory];
                    cloneInventory.push(cloneObj);
                    setSelectedInventory(cloneInventory);
                }
            } else if (inventoryId || singleInventoryId) {
                const id = inventoryId || singleInventoryId;
                if (inventoryPayload.inventoryId) {
                    delete inventoryPayload.inventoryId;
                }
                if (inventoryPayload.batchNumber) {
                    delete inventoryPayload.batchNumber;
                }
                inventoryPayload.conflictResolution = conflictResolution || conflictResolutionProp;
                response = await updateInventoryApi(id, batchNumber, filterUndefined(inventoryPayload));

                if (type === INVENTORY_TYPES.SAVED_SERVICE && response.status) {
                    const cloneObj = { ...response.data };
                    cloneObj.partQty = 1;
                    setSelectedInventory(updateObjectAtIndex(selectedInventory, cloneObj, selectedInventoryIndex));
                }
            } else {
                if (inventoryPayload.inventoryId) {
                    delete inventoryPayload.inventoryId;
                }
                if (inventoryPayload.batchNumber) {
                    delete inventoryPayload.batchNumber;
                }
                inventoryPayload.conflictResolution = conflictResolution || conflictResolutionProp;
                response = await addInventoryApi(filterUndefined(inventoryPayload));

                if (type === INVENTORY_TYPES.SAVED_SERVICE && response.status) {
                    const cloneObj = { ...response.data };
                    cloneObj.partQty = 1;
                    const cloneInventory = [...selectedInventory];
                    cloneInventory.push(cloneObj);
                    setSelectedInventory(cloneInventory);
                }
            }

            if (response?.data?._id) {
                queryClient.invalidateQueries({ queryKey: businessInventoryKeys.all, refetchType: 'all' });
                fetchApi(response?.data);
                handleClose();
            }

            return response;
        } catch (error) {
            console.error('Submission error:', error);
            throw error; // Re-throw to handle in the form submit
        } finally {
            setShowLoader(false);
        }
    };

    const handleClose = () => {
        reset();

        setAutoGeneratePartNumber(null);
        setValue('partNumber', null);
        setValue('partName', null);
        setValue('tyreDimension', null);
        setValue('supplierId', null);
        setValue('sold', 0);

        setValue('supplierId', null);
        setValue('supplierInvoiceNumber', null);
        setValue('partsBrand', null);
        setValue('partsCategory', null);
        setValue('tyreModelId', null);
        setValue('partsProvider', null);
        setValue('description', null);

        setValue('cost', 0);

        setValue('retailPrice', 0);
        setValue('marginPercentage', 0);
        setValue('markupPercentage', 0);
        setValue('feeAmount', 0);
        setValue('feeName', null);
        setValue('feeType', null);
        setValue('feePerUnit', 0);
        setValue('totalFee', 0);
        setValue('totalAfterFee', 0);
        setValue('totalRetailPrice', 0);
        setValue('totalProfit', 0);

        setIsFeeVisible(false);
        setIsAdditionalVisible(false);

        setTogglePartType(PART_TYPES.PARTS);
        setEditableRows([]);
        setInvoiceInput('');
        setSelectedPartsId(undefined);
        setIsUsedInCustomerInvoice(false);
        setPartCategoryId(undefined);
        setInventoryStatus(false);
        setEditModalTabValue(0);
        setInventroySearch('');
        setPartsProvider('');
        setBrandInput('');
        setPartsInput('');
        setCategoryInput('');
        setSupplierInput('');
        setTireModalInput('');
        setfeeInput('');
        setSingleInventoryId(null);

        fetchPartsApi('');
        fetchPartsBrandApi('');
        fetchSupplierList('');
        fetchPartsCategoryApi('');
        fetchTireModalApi('');

        closeModal();
    };
    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
        borderRadius: '30px',
        padding: '6px',
        background: '#E9E9EA',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        width: 'max-content',
        '.Mui-disabled': {
            border: 'none!important',
            borderColor: 'none!important',
        },
        '& .MuiToggleButton-root': {
            border: 'none',
            color: '#FFF',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            padding: '0 16px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            borderRadius: '50px',
            transition: 'none', // Disable hover effects
            textTransform: 'capitalize',
            height: '40px',

            '&.Mui-selected': {
                backgroundColor: '#006CDD',
                // border: "1px solid #0066E1",
                color: '#FFF',
                // boxShadow: "0px 2px 2px 0px rgba(0, 122, 255, 0.25)",
            },

            '&:not(.Mui-selected)': {
                backgroundColor: '#E9E9EA',
                // border: "1px solid #E9E9EA",
                color: '#000',
            },

            '&:not(.Mui-selected):hover': {
                backgroundColor: '#E9E9EA',
            },

            '&.Mui-selected:hover': {
                backgroundColor: '#007AFF',
            },
        },
    }));

    const renderUsedInvoiceQty = (field) => (
        <TextField
            {...field}
            inputRef={(el) => {
                qtyInputRef.current = el;
            }}
            disabled={true}
            fullWidth
            id="outlined-basic"
            variant="outlined"
            error={!!errors.qty}
            helperText={errors.qty ? errors.qty.message : ''}
            value={field.value}
            sx={MuiDisabledTextField}
        />
    );

    const renderTextField = (field) => (
        <TextField
            {...field}
            disabled={viewOnly || isUsedInCustomerInvoice}
            fullWidth
            id="outlined-basic"
            variant="outlined"
            error={!!errors.cost}
            helperText={errors.cost ? errors.cost.message : ''}
            sx={viewOnly || isUsedInCustomerInvoice ? MuiDisabledTextField : MuiTextFieldWithFocus}
            InputProps={{
                startAdornment: viewOnly || isUsedInCustomerInvoice ? null : <p style={{ paddingLeft: '0' }}>$</p>,
            }}
            onFocus={(event) => {
                // Move cursor to the end of the input
                const input = event.target;
                setTimeout(() => {
                    input.setSelectionRange(input.value.length, input.value.length);
                }, 0);
            }}
            value={viewOnly || isUsedInCustomerInvoice ? formatCurrency(field.value) : field.value}
            onKeyDown={handlePreventKeyDownDecimal}
            onChange={(event) => {
                const inputValue = event.target.value;
                let numericValue = inputValue.replace(/[^\d.]/g, '');

                if (numericValue.length > 1 && numericValue.startsWith('0') && /[1-9a-zA-Z]/.test(numericValue[1])) {
                    numericValue = numericValue.slice(1);
                }

                if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                    setValue('cost', numericValue);
                    const effectiveQty = getEffectiveQty();
                    if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                        calculateMarginChange(getValues().marginPercentage, effectiveQty, numericValue || 0);
                    }
                    if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                        calculateMarkupChange(getValues().markupPercentage, effectiveQty, numericValue || 0);
                    }
                    if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                        calculateRetailPriceChange(getValues().retailPrice, effectiveQty, numericValue || 0);
                    }
                    if (numericValue == '') {
                        setError('cost', {
                            type: 'manual',
                            message: 'Cost is required',
                        });
                    } else if (numericValue == 0) {
                        setError('cost', {
                            type: 'manual',
                            message: 'Cost cannot be 0',
                        });
                    } else {
                        clearErrors('cost');
                    }
                }
            }}
        />
    );

    //
    const [isFeeVisible, setIsFeeVisible] = useState(false);
    const [isAdditionalVisible, setIsAdditionalVisible] = useState(false);

    const [feeInput, setfeeInput] = useState('');
    const [feeModalLoading, setFeeModalLoading] = useState({
        fetch: false,
        save: false,
    });

    const feesList = useSelector((state) => state?.invoice?.feesList?.data) || [];

    const fetchFeesList = useCallback(async () => {
        try {
            setFeeModalLoading({ ...feeModalLoading, fetch: false });
            await dispatch(getInvoiceFeesListApi({ pagination: false, type: 'part' }));
        } catch (error) {
            setSuccessMessage('Error fetching fees data');
            console.error('Error fetching fees:', error);
        } finally {
            setFeeModalLoading({ ...feeModalLoading, fetch: false });
        }
    }, [dispatch]);

    useEffect(() => {
        if (openModal && batchNumber) {
            const getApi = async () => {
                try {
                    setUdateInventoryLoader(true);
                    // Dispatch the API call and wait for the response
                    const resp = await dispatch(getInventoryBatchDetailApi(batchNumber));

                    // Check if the response contains a valid IDxxx
                    if (resp && resp?._id) {
                        setTogglePartType(resp?.inventory?.partsType);
                        setValue('partName', resp?.inventory?.part?.partName);
                        setPartsInput(resp?.inventory?.part?.partName);

                        setSelectedPartsId(resp?.inventory?.part?._id);

                        setTimeout(() => {
                            setValue('tyreDimension', resp?.inventory?.tyreDimension);
                            setValue('partNumber', resp?.inventory?.partNumber);
                        }, 200);

                        setValue('description', resp?.inventory?.lastDescription);
                        if (resp?.inventory?.lastDescription) {
                            setIsAdditionalVisible(true);
                        }
                        setValue('partsCategory', resp?.inventory?.partsCategory?.name);
                        if (resp?.inventory?.partsCategory?._id) {
                            setIsAdditionalVisible(true);
                        }
                        setCategoryInput(resp?.inventory?.partsCategory?.name);
                        setValue('partsBrand', resp?.inventory?.partsBrand?.name);
                        if (resp?.inventory?.partsBrand?.name) {
                            setIsAdditionalVisible(true);
                        }
                        setBrandInput(resp?.inventory?.partsBrand?.name);

                        if (resp?.inventory?.tyreModel?._id) {
                            setIsAdditionalVisible(true);
                        }
                        setValue('tyreModelId', resp?.inventory?.tyreModel?.name);
                        setTireModalInput(resp?.inventory?.tyreModel?.name);
                        if (resp?.partsProvider) {
                            setValue('partsProvider', resp?.partsProvider);
                            setPartsProvider(resp?.partsProvider);
                            setIsAdditionalVisible(true);
                        }

                        if (resp?.supplierInvoice?.supplier?._id) {
                            setValue('supplierId', resp?.supplierInvoice?.supplier?._id);
                            setSupplierInput(resp?.supplierInvoice?.supplier?.name);
                        }

                        if (!addQty && disabledFields.length === 0 && resp?.supplierInvoice?.invoiceNumber) {
                            if (resp?.isUsedInCustomerInvoice && resp.isTracked) {
                                setValue('sold', resp?.sold || 0);
                                setIsUsedInCustomerInvoice(resp?.isUsedInCustomerInvoice);
                            }
                            setValue('supplierInvoiceNumber', resp?.supplierInvoice?.invoiceNumber);
                            setInvoiceInput(resp?.supplierInvoice?.invoiceNumber);
                        } else if (!addQty && disabledFields.length === 0) {
                            if (resp?.isUsedInCustomerInvoice) {
                                setValue('sold', resp?.sold || 0);
                                setIsUsedInCustomerInvoice(resp?.isUsedInCustomerInvoice);
                            }
                        }

                        if (!addQty && disabledFields.includes('supplierInvoiceNumber') && resp?.supplierInvoice?.invoiceNumber) {
                            setValue('supplierInvoiceNumber', resp?.supplierInvoice?.invoiceNumber);
                            setInvoiceInput(resp?.supplierInvoice?.invoiceNumber);
                        }

                        if (addQty && disabledFields.includes('supplierInvoiceNumber') && resp?.supplierInvoice?.invoiceNumber) {
                            if (resp?.isUsedInCustomerInvoice && resp.isTracked) {
                                setValue('sold', resp?.sold || 0);
                                setIsUsedInCustomerInvoice(resp?.isUsedInCustomerInvoice);
                            }
                            setValue('supplierInvoiceNumber', resp?.supplierInvoice?.invoiceNumber);
                            setInvoiceInput(resp?.supplierInvoice?.invoiceNumber);
                        }

                        // Set inventory-related values if available

                        let finalQty = 0;
                        let finalCost = 0;
                        let finalFee = 0;
                        let finalRetailPrice = resp?.inventory?.lastRetailPrice || 0;
                        let finalMarginPercentage = resp?.marginPercentage || 0;
                        let finalMarkupPercentage = resp?.markupPercentage || 0;
                        // if (isUseLastCost) {
                        //     finalQty = 1;
                        //     setValue('cost', resp?.inventory?.lastCost);
                        //     finalCost = resp?.inventory?.lastCost;
                        // } else {
                        //     finalQty = supplierInvoiceQty ? supplierInvoiceQty + stockPlusMinus : resp?.inStock + stockPlusMinus;
                        //     setValue('cost', supplierInvoiceCost || resp?.cost);
                        //     finalCost = supplierInvoiceCost || resp?.cost;
                        // }

                        // setValue('qty', finalQty);

                        // Create New from invoice: In Stock and Added to Invoice should reflect the new batch (e.g. 1), not the previous batch's stock
                        const isCreateNewFromInvoice =
                            conflictResolutionProp === 'create_new_part' &&
                            type === INVENTORY_TYPES.INVOICE &&
                            showUsedInInvoiceFeild &&
                            isUsedInvoiceQty !== null &&
                            isUsedInvoiceQty !== undefined;

                        if (isCreateNewFromInvoice) {
                            const newBatchQty = Number(isUsedInvoiceQty || 1);
                            setValue('qty', newBatchQty);
                            finalQty = newBatchQty;
                            setValue('cost', resp?.inventory?.lastCost);
                            finalCost = resp?.inventory?.lastCost ?? resp?.cost;
                        } else if (isUseLastCost) {
                            setValue('qty', resp?.inStock);
                            finalQty = 1;
                            setValue('cost', resp?.inventory?.lastCost);
                            finalCost = resp?.inventory?.lastCost;
                        } else {
                            // finalQty = supplierInvoiceQty ? supplierInvoiceQty + stockPlusMinus : resp?.inStock + stockPlusMinus;
                            // setValue('cost', supplierInvoiceCost || resp?.cost);
                            // finalCost = supplierInvoiceCost || resp?.cost;
                            setValue('qty', supplierInvoiceQty ? supplierInvoiceQty + stockPlusMinus : resp?.inStock + stockPlusMinus);
                            finalQty = supplierInvoiceQty ? supplierInvoiceQty + stockPlusMinus : resp?.inStock + stockPlusMinus;
                            setValue('cost', supplierInvoiceCost || resp?.cost);
                            finalCost = supplierInvoiceCost || resp?.cost;
                        }

                        const pricingMethod = resp?.inventory?.lastPricingMethod;
                        setValue('pricingMethod', pricingMethod);
                        // When opened from invoice with showUsedInInvoiceFeild, use isUsedInvoiceQty for billedQty
                        if (showUsedInInvoiceFeild && type === INVENTORY_TYPES.INVOICE && isUsedInvoiceQty !== null && isUsedInvoiceQty !== undefined) {
                            setValue('billedQty', Number(isUsedInvoiceQty || 0));
                        } else {
                            setValue('billedQty', finalQty);
                        }

                        if (resp?.inventory?.feeAmount) {
                            setValue('feeAmount', resp?.inventory?.feeAmount);
                            finalFee = resp?.inventory?.feeAmount || 0;
                        }
                        if (resp?.inventory?.fee?._id || resp?.inventory?.fee?.name) {
                            setIsFeeVisible(true);
                            setValue('feeName', resp?.inventory?.fee?.name);
                        }

                        // Use effective quantity for calculations when opened from invoice
                        const effectiveQty =
                            showUsedInInvoiceFeild && type === INVENTORY_TYPES.INVOICE && isUsedInvoiceQty !== null && isUsedInvoiceQty !== undefined
                                ? Number(isUsedInvoiceQty || 0)
                                : finalQty;

                        if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                            calculateRetailPriceChange(finalRetailPrice, effectiveQty, finalCost, finalFee);
                        }

                        if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                            calculateMarginChange(finalMarginPercentage, effectiveQty, finalCost, finalFee);
                        }

                        if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                            calculateMarkupChange(finalMarkupPercentage, effectiveQty, finalCost, finalFee);
                        }
                    }
                    setUdateInventoryLoader(false);
                } catch (error) {
                    console.error('Error fetching inventory data:', error);
                    setUdateInventoryLoader(false);
                    // Optionally, display an error message to the user
                } finally {
                    setUdateInventoryLoader(false);
                }
            };

            getApi();
        } else if (openModal) {
            fetchDefaultShopPrice();
        }
        if (openModal) {
            fetchFeesList();
        }
    }, [singleInventoryId, inventoryId, batchNumber, openModal, fetchFeesList]); // Ensure the useEffect triggers on change of singleInventoryId or inventoryId

    useEffect(() => {
        fetchConfig();
        // if (autoGeneratePartNumberFlag && autoGenratePartNumber) {
        //     setValue('partNumber', autoGenratePartNumber);
        // } else {
        //     fetchConfig();
        // }

        if (batchNumber || conflictResolutionProp === 'create_new_part') {
            setValue('partNumber', '');
        }
    }, [openModal]);

    // Helper function to get the effective quantity for calculations
    // When opened from invoice with showUsedInInvoiceFeild, use isUsedInvoiceQty
    const getEffectiveQty = () => {
        if (showUsedInInvoiceFeild && type === INVENTORY_TYPES.INVOICE && isUsedInvoiceQty !== null && isUsedInvoiceQty !== undefined) {
            return Number(isUsedInvoiceQty || 0);
        }
        return Number(getValues().qty || 0);
    };

    const calculateRetailPriceChange = (rp, qty, cost, fee = null) => {
        const retailPrice = rp === '' ? 0 : Number(rp);
        const feeAmount = fee || getValues()?.feeAmount || 0;
        const marginPercentage = NumericEngine.calculateMarginPercentageFromRetail(cost, retailPrice);

        const markupPercentage = NumericEngine.calculateMarkupPercentageFromRetail(cost, retailPrice);

        // Calculate derived values
        const profitPerUnit = NumericEngine.subtract(retailPrice, cost);
        const totalRetail = NumericEngine.multiply(retailPrice, qty);
        const totalProfit = NumericEngine.multiply(profitPerUnit, qty);

        const totalFee = NumericEngine.multiply(feeAmount, qty);
        const totalAfterFee = NumericEngine.add(totalRetail, totalFee);

        // Update form values - use margin percentage when manual price is selected
        setValue('retailPrice', rp.toString(), { shouldValidate: true });
        setValue('marginPercentage', marginPercentage.toString(), {
            shouldValidate: true,
        });
        setValue('markupPercentage', markupPercentage.toString(), {
            shouldValidate: true,
        });
        setValue('profitPerUnit', profitPerUnit.toString(), {
            shouldValidate: true,
        });
        setValue('totalRetailPrice', totalRetail.toString(), {
            shouldValidate: true,
        });
        setValue('totalProfit', totalProfit.toString(), { shouldValidate: true });
        setValue('totalFee', totalFee.toString(), { shouldValidate: true });
        setValue('totalAfterFee', totalAfterFee.toString(), { shouldValidate: true });
    };

    const calculateMarginChange = (mp, qty, cost, fee = null) => {
        const marginPercentage = mp === '' ? 0 : Number(mp);

        const feeAmount = fee || getValues()?.feeAmount || 0;
        const retailPrice = NumericEngine.calculateRetailFromMargin(cost, marginPercentage);

        const markupPercentage = NumericEngine.calculateMarkupPercentageFromRetail(cost, retailPrice);

        // Calculate derived values
        const profitPerUnit = NumericEngine.subtract(retailPrice, cost);
        const totalRetail = NumericEngine.multiply(retailPrice, qty);
        const totalProfit = NumericEngine.multiply(profitPerUnit, qty);

        const totalFee = NumericEngine.multiply(feeAmount, qty);
        const totalAfterFee = NumericEngine.add(totalRetail, totalFee);
        // Update form values - use margin percentage when manual price is selected
        setValue('retailPrice', retailPrice.toString(), { shouldValidate: true });

        setValue('marginPercentage', mp.toString(), {
            shouldValidate: true,
        });
        setValue('markupPercentage', markupPercentage.toString(), {
            shouldValidate: true,
        });
        setValue('profitPerUnit', profitPerUnit.toString(), {
            shouldValidate: true,
        });
        setValue('totalRetailPrice', totalRetail.toString(), {
            shouldValidate: true,
        });
        setValue('totalProfit', totalProfit.toString(), { shouldValidate: true });

        setValue('totalFee', totalFee.toString(), { shouldValidate: true });
        setValue('totalAfterFee', totalAfterFee.toString(), { shouldValidate: true });
    };

    const calculateMarkupChange = (mp, qty, cost, fee = null) => {
        const markupPercentage = mp === '' ? 0 : Number(mp);
        const feeAmount = fee || getValues()?.feeAmount || 0;
        const retailPrice = NumericEngine.calculateRetailFromMarkup(cost, markupPercentage);

        const marginPercentage = NumericEngine.calculateMarginPercentageFromRetail(cost, retailPrice);

        // Calculate derived values
        const profitPerUnit = NumericEngine.subtract(retailPrice, cost);
        const totalRetail = NumericEngine.multiply(retailPrice, qty);
        const totalProfit = NumericEngine.multiply(profitPerUnit, qty);

        const totalFee = NumericEngine.multiply(feeAmount, qty);
        const totalAfterFee = NumericEngine.add(totalRetail, totalFee);

        // Update form values - use margin percentage when manual price is selected
        setValue('retailPrice', retailPrice.toString(), { shouldValidate: true });

        setValue('marginPercentage', marginPercentage.toString(), {
            shouldValidate: true,
        });
        setValue('markupPercentage', mp.toString(), {
            shouldValidate: true,
        });
        setValue('profitPerUnit', profitPerUnit.toString(), {
            shouldValidate: true,
        });
        setValue('totalRetailPrice', totalRetail.toString(), {
            shouldValidate: true,
        });
        setValue('totalProfit', totalProfit.toString(), { shouldValidate: true });
        setValue('totalFee', totalFee.toString(), { shouldValidate: true });
        setValue('totalAfterFee', totalAfterFee.toString(), { shouldValidate: true });
    };

    /* Manual Price  */
    const renderManualPrice = () => (
        <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
            <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Radio
                        checked={getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE}
                        onChange={(event) => {
                            if (event.target.checked) {
                                setValue('pricingMethod', PRICING_METHOD.RETAIL_PRICE);
                                const effectiveQty = getEffectiveQty();
                                const cost = Number(getValues().cost || 0);

                                calculateRetailPriceChange(getValues().retailPrice, effectiveQty, cost);
                            }
                        }}
                        value="retailPrice"
                        disabled={viewOnly}
                        size="small"
                        sx={{
                            padding: 0,
                            margin: 0,
                            '& .MuiSvgIcon-root': {
                                fontSize: '1.25rem',
                            },
                        }}
                    />
                    <Typography
                        variant="body1"
                        style={{
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '0.15px',
                        }}
                    >
                        Manual price<span style={{ color: '#D32F2F' }}> *</span>
                    </Typography>
                </Stack>

                <Controller
                    name="retailPrice"
                    control={control}
                    render={({ field }) => {
                        const retailPriceWatched = watch('retailPrice');
                        const costWatched = watch('cost');
                        const qtyWatched = watch('qty');

                        const currentValue = retailPriceWatched || field.value;
                        const displayValue = viewOnly
                            ? NumericEngine.format(currentValue || 0, { trailingZeros: true, formatCurrency: true })
                            : getValues('pricingMethod') === PRICING_METHOD.RETAIL_PRICE
                              ? currentValue
                              : NumericEngine.format(currentValue || 0, { trailingZeros: true, formatCurrency: true });

                        return (
                            <TextField
                                {...field}
                                fullWidth
                                variant="outlined"
                                value={displayValue}
                                disabled={viewOnly || getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE}
                                sx={viewOnly || getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                onChange={(event) => {
                                    const inputValue = event.target.value;
                                    const numericValue = inputValue.replace(/[^\d.]/g, '');

                                    if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                        const effectiveQty = getEffectiveQty();
                                        const cost = Number(costWatched || getValues().cost || 0);

                                        calculateRetailPriceChange(numericValue, effectiveQty, cost);
                                    }
                                }}
                                InputProps={{
                                    startAdornment:
                                        viewOnly || isUsedInCustomerInvoice || getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE ? null : (
                                            <p
                                                style={{
                                                    paddingLeft: '0',
                                                }}
                                            >
                                                $
                                            </p>
                                        ),
                                }}
                            />
                        );
                    }}
                />
            </Stack>
        </Grid>
    );

    /* Margin Percentage  */
    const renderMarginPrice = () => (
        <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
            <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Radio
                        checked={getValues().pricingMethod === PRICING_METHOD.MARGIN}
                        onChange={(event) => {
                            if (event.target.checked) {
                                setValue('pricingMethod', PRICING_METHOD.MARGIN);

                                const effectiveQty = getEffectiveQty();
                                const cost = Number(getValues().cost || 0);

                                calculateMarginChange(getValues().marginPercentage, effectiveQty, cost);
                            }
                        }}
                        value="marginPercentage"
                        disabled={viewOnly}
                        size="small"
                        sx={{
                            padding: 0,
                            margin: 0,
                            '& .MuiSvgIcon-root': {
                                fontSize: '1.25rem',
                            },
                        }}
                    />
                    <Typography
                        variant="body1"
                        style={{
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '0.15px',
                        }}
                    >
                        Margin %<span style={{ color: '#D32F2F' }}> *</span>
                    </Typography>
                </Stack>

                <Controller
                    name="marginPercentage"
                    control={control}
                    render={({ field }) => {
                        const marginPercentageWatched = watch('marginPercentage');
                        const costWatched = watch('cost');
                        const qtyWatched = watch('qty');

                        const currentValue = marginPercentageWatched || field.value;
                        const isDisabled = viewOnly || getValues('pricingMethod') !== PRICING_METHOD.MARGIN;
                        const formattedValue = viewOnly
                            ? NumericEngine.format(currentValue, { trailingZeros: true })
                            : getValues('pricingMethod') === PRICING_METHOD.MARGIN
                              ? currentValue
                              : NumericEngine.format(currentValue, { trailingZeros: true });

                        const displayValue = isDisabled ? `${formattedValue}%` : formattedValue;

                        return (
                            <TextField
                                {...field}
                                fullWidth
                                variant="outlined"
                                value={displayValue}
                                disabled={isDisabled}
                                onChange={(event) => {
                                    const inputValue = event.target.value;
                                    const numericValue = inputValue.replace(/[^\d.]/g, '');

                                    if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                        const effectiveQty = getEffectiveQty();
                                        const cost = Number(costWatched || getValues().cost || 0);

                                        calculateMarginChange(numericValue, effectiveQty, cost);
                                    }
                                }}
                                sx={isDisabled ? MuiDisabledTextField : MuiTextFieldWithFocus}
                            />
                        );
                    }}
                />
            </Stack>
        </Grid>
    );

    /* Markup Percentage  */
    const renderMarkupPrice = () => (
        <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
            <Stack spacing={1}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Radio
                        checked={getValues().pricingMethod === PRICING_METHOD.MARKUP}
                        onChange={(event) => {
                            if (event.target.checked) {
                                setValue('pricingMethod', PRICING_METHOD.MARKUP);

                                const effectiveQty = getEffectiveQty();
                                const cost = Number(getValues().cost || 0);

                                calculateMarkupChange(getValues().markupPercentage, effectiveQty, cost);
                            }
                        }}
                        value="markupPercentage"
                        disabled={viewOnly}
                        size="small"
                        sx={{
                            padding: 0,
                            margin: 0,
                            '& .MuiSvgIcon-root': {
                                fontSize: '1.25rem',
                            },
                        }}
                    />
                    <Typography
                        variant="body1"
                        style={{
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '0.15px',
                        }}
                    >
                        Markup %<span style={{ color: '#D32F2F' }}> *</span>
                    </Typography>
                </Stack>

                <Controller
                    name="markupPercentage"
                    control={control}
                    render={({ field }) => {
                        const markupPercentageWatched = watch('markupPercentage');
                        const costWatched = watch('cost');
                        const qtyWatched = watch('qty');

                        const currentValue = markupPercentageWatched || field.value;
                        const isDisabled = viewOnly || getValues('pricingMethod') !== PRICING_METHOD.MARKUP;
                        const formattedValue = viewOnly
                            ? NumericEngine.format(currentValue, { trailingZeros: true })
                            : getValues('pricingMethod') === PRICING_METHOD.MARKUP
                              ? currentValue
                              : NumericEngine.format(currentValue, { trailingZeros: true });

                        const displayValue = isDisabled ? `${formattedValue}%` : formattedValue;

                        return (
                            <TextField
                                {...field}
                                fullWidth
                                variant="outlined"
                                value={displayValue}
                                disabled={isDisabled}
                                onChange={(event) => {
                                    const inputValue = event.target.value;
                                    const numericValue = inputValue.replace(/[^\d.]/g, '');

                                    if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                        const effectiveQty = getEffectiveQty();
                                        const cost = Number(costWatched || getValues().cost || 0);

                                        calculateMarkupChange(numericValue, effectiveQty, cost);
                                    }
                                }}
                                sx={isDisabled ? MuiDisabledTextField : MuiTextFieldWithFocus}
                            />
                        );
                    }}
                />
            </Stack>
        </Grid>
    );

    const PRICE_BLOCKS = {
        margin: renderMarginPrice,
        retail_price: renderManualPrice,
        markup: renderMarkupPrice,
    };

    return (
        <>
            <Dialog
                className="commonDialog__1100"
                open={openModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && !showLoader) {
                        handleClose();
                        onSubmitModal();
                    }
                }}
                disableBackdropClick
                maxWidth="sm"
                fullWidth
            >
                <form
                    onSubmit={(event) => {
                        event.preventDefault(); // Prevent default form behavior
                        event.stopPropagation(); // Prevent propagation to parent form

                        handleSubmit(onSubmit)(event).catch((error) => {
                            console.error('Form submission failed:', error);
                        });
                    }}
                >
                    {/* Dialog Header */}
                    <DialogTitle
                        sx={{
                            padding: '16px!important',
                            color: 'white',
                            height: '64px',
                            borderRadius: '8px 8px 0px 0px !important',
                            display: 'flex',
                            justifyContent: 'space-between',
                            borderBottom: '1px solid #0000001F',
                        }}
                    >
                        {updateInventoryLoader ? (
                            <di style={{ width: '98%' }}>
                                <Skeleton variant="text" sx={{ fontSize: '1rem', width: '90px' }} />
                            </di>
                        ) : (
                            <Typography variant="h6" width={'98%'} color={'#000000DE'}>
                                {viewOnly
                                    ? togglePartType === PART_TYPES.PARTS
                                        ? 'Part Details'
                                        : 'Tire Details'
                                    : inventoryId
                                      ? togglePartType === PART_TYPES.PARTS
                                          ? 'Edit Part'
                                          : 'Edit Tire'
                                      : togglePartType === PART_TYPES.PARTS
                                        ? 'Add Part'
                                        : 'Add Tire'}
                            </Typography>
                        )}

                        <Stack direction={'row'} spacing={0}>
                            <div
                                onClick={() => {
                                    if (!showLoader) {
                                        if (isAddPartBtn) {
                                            setIsAddPartAgain(false);
                                        }
                                        handleClose();
                                        // onSubmitModal();
                                    }
                                }}
                                style={{ cursor: 'pointer', height: '32px' }}
                            >
                                <CloseIcon style={{ fill: '#000000DE', fontSize: 32 }} />
                            </div>
                        </Stack>
                    </DialogTitle>

                    <DialogContent
                        ref={dialogContentRef}
                        sx={{
                            padding: '24px 24px 0 24px!important',
                            minHeight: '479px',
                            height: '100%',
                            maxHeight: '74vh',
                            overflow: 'auto',
                        }}
                    >
                        {updateInventoryLoader ? (
                            <CircularProgress
                                size={50}
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-25px', // Half of the size
                                    marginLeft: '-25px', // Half of the size
                                }}
                            />
                        ) : (
                            <Grid container>
                                {
                                    // ShowAllTabs
                                    false && (
                                        <Tabs
                                            value={editModalTabvalue}
                                            onChange={handleChangeEditCustomerTabValue}
                                            aria-label="basic tabs example"
                                            sx={{ marginBottom: '24px' }}
                                        >
                                            <Tab label="ADD MANUALLY" {...a11yProps(0)} />

                                            <Tab
                                                label={
                                                    <span>
                                                        INVENTORY LISTING{' '}
                                                        {selectedInventory?.length > 0 && (
                                                            <Badge
                                                                badgeContent={selectedInventory.length} // Badge content (e.g., the number 5)
                                                                color="secondary" // Badge color
                                                                sx={{ marginLeft: 2, marginBottom: 1 }} // Adjust the position of the badge
                                                            />
                                                        )}
                                                    </span>
                                                }
                                                {...a11yProps(1)}
                                            />
                                        </Tabs>
                                    )
                                }

                                <div
                                    style={{
                                        display: editModalTabvalue == 0 ? 'block' : 'none',
                                    }}
                                >
                                    <Grid item container mb={3}>
                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                                            <Typography fontWeight={500} fontSize={'24px'} color={'#000000DE'} display={'flex'} alignItems={'center'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                    <path
                                                        d="M27.9467 21.933C27.96 21.733 28 21.533 28 21.333V21.9997L27.9467 21.933ZM14.6667 21.333C14.6667 22.2797 14.8667 23.1863 15.2267 23.9997H8V25.333C8 26.0663 7.4 26.6663 6.66667 26.6663H5.33333C4.6 26.6663 4 26.0663 4 25.333V14.6663L6.77333 6.66634C7.04 5.89301 7.78667 5.33301 8.66667 5.33301H23.3333C24.2133 5.33301 24.96 5.89301 25.2267 6.66634L28 14.6663V21.333C28 17.653 25.0133 14.6663 21.3333 14.6663C17.6533 14.6663 14.6667 17.653 14.6667 21.333ZM10.6667 17.9997C10.6667 16.893 9.77333 15.9997 8.66667 15.9997C7.56 15.9997 6.66667 16.893 6.66667 17.9997C6.66667 19.1063 7.56 19.9997 8.66667 19.9997C9.77333 19.9997 10.6667 19.1063 10.6667 17.9997ZM25.3333 13.333L23.3333 7.33301H8.66667L6.66667 13.333H25.3333ZM30.4933 28.253L25.0133 22.773C25.56 21.3863 25.2533 19.7597 24.1067 18.6263C22.9067 17.413 21.1067 17.173 19.6533 17.8397L22.24 20.4263L20.44 22.2397L17.7867 19.6397C17.0667 21.093 17.4 22.893 18.5733 24.1063C19.1029 24.6465 19.7788 25.0202 20.5179 25.1812C21.257 25.3423 22.027 25.2839 22.7333 25.013L28.2133 30.4797C28.4533 30.733 28.8133 30.733 29.0533 30.4797L30.44 29.1063C30.7333 28.8663 30.7333 28.4397 30.4933 28.253Z"
                                                        fill="#2196F3"
                                                    />
                                                </svg>{' '}
                                                {togglePartType === PART_TYPES.PARTS ? 'Part Details' : 'Tire Details'}
                                            </Typography>

                                            <StyledToggleButtonGroup
                                                exclusive
                                                size="small"
                                                value={togglePartType}
                                                disabled={viewOnly}
                                                style={{ opacity: viewOnly ? 0.5 : 1 }}
                                                onChange={(event, newValue) => {
                                                    if (newValue !== null && newValue !== togglePartType) {
                                                        setValue('partName', '');
                                                        setPartsInput('');
                                                        setValue('tyreModelId', '');
                                                        setTireModalInput('');
                                                        setPartCategoryId(undefined);
                                                        setValue('partNumber', '');
                                                        setValue('tyreDimension', '');
                                                        setCategoryInput('');
                                                        clearErrors('tyreDimension');
                                                        clearErrors('partNumber');
                                                        setCaretPosition(0);
                                                        setTogglePartType(newValue);
                                                    } else {
                                                    }
                                                }}
                                            >
                                                <ToggleButton value={PART_TYPES.PARTS} aria-label="left aligned" style={{ display: 'flex', gap: '6px' }}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill={togglePartType === PART_TYPES.PARTS ? 'white' : 'black'}
                                                    >
                                                        <path d="M13.7506 1.25001C12.9972 1.24984 12.2535 1.41994 11.575 1.74758C10.8966 2.07522 10.301 2.55194 9.83268 3.14212C9.36438 3.7323 9.03551 4.42068 8.87064 5.15583C8.70577 5.89097 8.70916 6.65386 8.88056 7.38751L2.56681 13.9313C2.12027 14.4049 1.87764 15.035 1.89116 15.6858C1.90469 16.3366 2.17329 16.956 2.63911 17.4107C3.10494 17.8654 3.73072 18.1189 4.38166 18.1167C5.0326 18.1145 5.65662 17.8566 6.11931 17.3988L12.3781 11.0588C13.1767 11.2861 14.0193 11.311 14.83 11.1314C15.6407 10.9517 16.3939 10.5731 17.0217 10.0296C17.6495 9.48612 18.1322 8.79493 18.4261 8.01835C18.7201 7.24176 18.8161 6.40422 18.7056 5.58126C18.6902 5.46555 18.6428 5.35646 18.5686 5.26633C18.4944 5.1762 18.3965 5.10864 18.2859 5.07131C18.1753 5.03397 18.0565 5.02834 17.9429 5.05506C17.8293 5.08179 17.7254 5.13979 17.6431 5.22251L15.0006 7.86626L12.1343 5.00001L14.7781 2.35626C14.8608 2.27391 14.9188 2.17005 14.9455 2.05643C14.9722 1.94281 14.9666 1.82398 14.9293 1.71339C14.8919 1.6028 14.8244 1.50488 14.7342 1.43072C14.6441 1.35656 14.535 1.30911 14.4193 1.29376C14.1972 1.26418 13.9734 1.24956 13.7493 1.25001" />
                                                    </svg>
                                                    Part
                                                </ToggleButton>

                                                <ToggleButton value={PART_TYPES.TYRE} aria-label="left aligned" style={{ display: 'flex', gap: '6px' }}>
                                                    {togglePartType === PART_TYPES.PARTS ? (
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                            <g clip-path="url(#clip0_7988_57814)">
                                                                <path
                                                                    d="M11.0013 3.66699C6.95778 3.66699 3.66797 6.95681 3.66797 11.0003C3.66797 15.0439 6.95778 18.3337 11.0013 18.3337C15.0448 18.3337 18.3347 15.0439 18.3347 11.0003C18.3347 6.95681 15.0448 3.66699 11.0013 3.66699ZM14.753 6.40625C14.794 6.36085 14.8436 6.3241 14.8989 6.2982C14.9543 6.27229 15.0142 6.25775 15.0753 6.25543C15.1818 6.24336 15.3188 6.29526 15.4083 6.3803C16.359 7.28041 17.0053 8.42625 17.2757 9.69383C17.3186 9.89613 17.221 10.102 17.0375 10.1969C16.589 10.4288 16.0564 10.5411 15.5462 10.5411C14.8811 10.5411 14.2508 10.3504 13.8856 9.98516C13.1086 9.20863 13.4326 7.8708 14.753 6.40625ZM7.24963 15.666C7.20874 15.7115 7.15916 15.7483 7.10381 15.7743C7.04846 15.8003 6.98846 15.8149 6.92736 15.8173C6.92199 15.8177 6.91572 15.8177 6.90945 15.8177C6.79225 15.8178 6.67948 15.773 6.59436 15.6924C5.64367 14.7923 4.99734 13.6464 4.72702 12.3784C4.68405 12.1761 4.78163 11.9702 4.96515 11.8754C5.99821 11.3423 7.47165 11.4416 8.11708 12.0871C8.89318 12.8637 8.56911 14.2015 7.24963 15.666ZM8.11704 9.9852C7.7518 10.3504 7.12158 10.5411 6.45647 10.5411C5.94621 10.5411 5.41448 10.4288 4.96511 10.197C4.87578 10.1508 4.8041 10.0765 4.76108 9.98563C4.71805 9.89474 4.70607 9.79224 4.72698 9.69387C4.99734 8.4263 5.64363 7.28045 6.59431 6.38034C6.68382 6.2953 6.81543 6.2425 6.92732 6.25547C6.98839 6.2578 7.04837 6.27235 7.10372 6.29826C7.15907 6.32416 7.20867 6.3609 7.24959 6.40629C8.57002 7.8708 8.89404 9.20863 8.11704 9.9852ZM12.9546 17.1122C12.3199 17.3145 11.6628 17.417 11.0013 17.417C10.3398 17.417 9.68269 17.3146 9.04804 17.1122C8.84661 17.0478 8.71503 16.8544 8.72934 16.6436C8.84394 14.9942 9.82058 13.7503 11.0013 13.7503C12.1821 13.7503 13.1587 14.9942 13.2733 16.6436C13.2802 16.7461 13.2526 16.8479 13.1948 16.9329C13.137 17.0178 13.0525 17.081 12.9546 17.1122ZM9.16797 11.0003C9.16797 9.98924 9.99065 9.16699 11.0013 9.16699C12.012 9.16699 12.8347 9.9892 12.8347 11.0003C12.8347 12.0115 12.012 12.8337 11.0013 12.8337C9.99065 12.8337 9.16797 12.0114 9.16797 11.0003ZM13.2733 5.39335C13.1587 7.04227 12.1821 8.28613 11.0013 8.28613C9.82058 8.28613 8.84394 7.04227 8.72934 5.39335C8.71503 5.18254 8.8457 4.98918 9.04714 4.92516C10.3184 4.51962 11.6843 4.51962 12.9555 4.92516C13.1569 4.98918 13.2876 5.18254 13.2733 5.39335ZM17.2757 12.3055C17.0053 13.5735 16.359 14.7194 15.4083 15.6195C15.3232 15.7 15.2104 15.7449 15.0932 15.7448C15.087 15.7448 15.0807 15.7448 15.0753 15.7444C15.0142 15.7421 14.9543 15.7275 14.8989 15.7016C14.8436 15.6757 14.794 15.639 14.753 15.5936C13.4327 14.1291 13.1086 12.7908 13.8856 12.0142C14.531 11.3683 16.0036 11.2703 17.0375 11.8025C17.1268 11.8487 17.1985 11.9229 17.2416 12.0138C17.2846 12.1047 17.2966 12.2072 17.2757 12.3055Z"
                                                                    fill="black"
                                                                />
                                                                <path
                                                                    d="M11 0C4.93423 0 0 4.9347 0 11C0 17.0653 4.93423 22 11 22C17.0658 22 22 17.0653 22 11C22 4.9347 17.0658 0 11 0ZM11 19.25C6.45068 19.25 2.75 15.5489 2.75 11C2.75 6.45111 6.45068 2.75 11 2.75C15.5493 2.75 19.25 6.45111 19.25 11C19.25 15.5489 15.5493 19.25 11 19.25Z"
                                                                    fill="black"
                                                                />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_7988_57814">
                                                                    <rect width="22" height="22" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    ) : (
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                            <g clip-path="url(#clip0_7988_58709)">
                                                                <path
                                                                    d="M11.0013 3.66699C6.95778 3.66699 3.66797 6.95681 3.66797 11.0003C3.66797 15.0439 6.95778 18.3337 11.0013 18.3337C15.0448 18.3337 18.3347 15.0439 18.3347 11.0003C18.3347 6.95681 15.0448 3.66699 11.0013 3.66699ZM14.753 6.40625C14.794 6.36085 14.8436 6.3241 14.8989 6.2982C14.9543 6.27229 15.0142 6.25775 15.0753 6.25543C15.1818 6.24336 15.3188 6.29526 15.4083 6.3803C16.359 7.28041 17.0053 8.42625 17.2757 9.69383C17.3186 9.89613 17.221 10.102 17.0375 10.1969C16.589 10.4288 16.0564 10.5411 15.5462 10.5411C14.8811 10.5411 14.2508 10.3504 13.8856 9.98516C13.1086 9.20863 13.4326 7.8708 14.753 6.40625ZM7.24963 15.666C7.20874 15.7115 7.15916 15.7483 7.10381 15.7743C7.04846 15.8003 6.98846 15.8149 6.92736 15.8173C6.92199 15.8177 6.91572 15.8177 6.90945 15.8177C6.79225 15.8178 6.67948 15.773 6.59436 15.6924C5.64367 14.7923 4.99734 13.6464 4.72702 12.3784C4.68405 12.1761 4.78163 11.9702 4.96515 11.8754C5.99821 11.3423 7.47165 11.4416 8.11708 12.0871C8.89318 12.8637 8.56911 14.2015 7.24963 15.666ZM8.11704 9.9852C7.7518 10.3504 7.12158 10.5411 6.45647 10.5411C5.94621 10.5411 5.41448 10.4288 4.96511 10.197C4.87578 10.1508 4.8041 10.0765 4.76108 9.98563C4.71805 9.89474 4.70607 9.79224 4.72698 9.69387C4.99734 8.4263 5.64363 7.28045 6.59431 6.38034C6.68382 6.2953 6.81543 6.2425 6.92732 6.25547C6.98839 6.2578 7.04837 6.27235 7.10372 6.29826C7.15907 6.32416 7.20867 6.3609 7.24959 6.40629C8.57002 7.8708 8.89404 9.20863 8.11704 9.9852ZM12.9546 17.1122C12.3199 17.3145 11.6628 17.417 11.0013 17.417C10.3398 17.417 9.68269 17.3146 9.04804 17.1122C8.84661 17.0478 8.71503 16.8544 8.72934 16.6436C8.84394 14.9942 9.82058 13.7503 11.0013 13.7503C12.1821 13.7503 13.1587 14.9942 13.2733 16.6436C13.2802 16.7461 13.2526 16.8479 13.1948 16.9329C13.137 17.0178 13.0525 17.081 12.9546 17.1122ZM9.16797 11.0003C9.16797 9.98924 9.99065 9.16699 11.0013 9.16699C12.012 9.16699 12.8347 9.9892 12.8347 11.0003C12.8347 12.0115 12.012 12.8337 11.0013 12.8337C9.99065 12.8337 9.16797 12.0114 9.16797 11.0003ZM13.2733 5.39335C13.1587 7.04227 12.1821 8.28613 11.0013 8.28613C9.82058 8.28613 8.84394 7.04227 8.72934 5.39335C8.71503 5.18254 8.8457 4.98918 9.04714 4.92516C10.3184 4.51962 11.6843 4.51962 12.9555 4.92516C13.1569 4.98918 13.2876 5.18254 13.2733 5.39335ZM17.2757 12.3055C17.0053 13.5735 16.359 14.7194 15.4083 15.6195C15.3232 15.7 15.2104 15.7449 15.0932 15.7448C15.087 15.7448 15.0807 15.7448 15.0753 15.7444C15.0142 15.7421 14.9543 15.7275 14.8989 15.7016C14.8436 15.6757 14.794 15.639 14.753 15.5936C13.4327 14.1291 13.1086 12.7908 13.8856 12.0142C14.531 11.3683 16.0036 11.2703 17.0375 11.8025C17.1268 11.8487 17.1985 11.9229 17.2416 12.0138C17.2846 12.1047 17.2966 12.2072 17.2757 12.3055Z"
                                                                    fill="white"
                                                                />
                                                                <path
                                                                    d="M11 0C4.93423 0 0 4.9347 0 11C0 17.0653 4.93423 22 11 22C17.0658 22 22 17.0653 22 11C22 4.9347 17.0658 0 11 0ZM11 19.25C6.45068 19.25 2.75 15.5489 2.75 11C2.75 6.45111 6.45068 2.75 11 2.75C15.5493 2.75 19.25 6.45111 19.25 11C19.25 15.5489 15.5493 19.25 11 19.25Z"
                                                                    fill="white"
                                                                />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_7988_58709">
                                                                    <rect width="22" height="22" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    )}
                                                    Tire
                                                </ToggleButton>
                                            </StyledToggleButtonGroup>
                                        </Stack>
                                    </Grid>

                                    <Grid container spacing={3}>
                                        {togglePartType === PART_TYPES.PARTS ? (
                                            <Grid item xs={12} sm={6} xl={2}>
                                                <Stack spacing={1}>
                                                    <Typography
                                                        variant="body1"
                                                        className="label--500"
                                                        style={{
                                                            letterSpacing: '0.15px',
                                                        }}
                                                    >
                                                        Part Number
                                                        {!autoGeneratePartNumberFlag && <span style={{ color: '#D32F2F' }}> *</span>}
                                                    </Typography>
                                                    <Controller
                                                        name="partNumber"
                                                        control={control}
                                                        rules={{
                                                            required: autoGeneratePartNumberFlag ? false : 'Part number is required.',
                                                        }}
                                                        render={({ field }) => (
                                                            <TextField
                                                                disabled={viewOnly || disabledFields.includes('partNumber')}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                variant="outlined"
                                                                onChange={(value) => {
                                                                    field.onChange(value.target.value);
                                                                }}
                                                                value={field.value}
                                                                error={!!errors.partNumber}
                                                                helperText={errors.partNumber ? errors.partNumber.message : ''}
                                                                sx={
                                                                    viewOnly || disabledFields.includes('partNumber')
                                                                        ? MuiDisabledTextField
                                                                        : MuiTextFieldWithFocus
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} sm={6} xl={2}>
                                                <Stack spacing={1}>
                                                    <Typography
                                                        variant="body1"
                                                        className="label--500"
                                                        style={{
                                                            letterSpacing: '0.15px',
                                                        }}
                                                    >
                                                        Tire Dimensions
                                                        <span style={{ color: '#D32F2F' }}> *</span>
                                                    </Typography>
                                                    <Controller
                                                        name="tyreDimension"
                                                        control={control}
                                                        rules={{
                                                            required: 'Dimension is required',
                                                            validate: (value) => {
                                                                return /^(\d{3})\/(\d{2})\/R(\d{2})$/.test(value) || 'Invalid tire dimension format';
                                                            },
                                                        }}
                                                        render={({ field }) => (
                                                            <TextField
                                                                disabled={viewOnly || disabledFields.includes('partNumber')}
                                                                fullWidth
                                                                variant="outlined"
                                                                placeholder="XXX/XX/RXX"
                                                                value={field.value || ''}
                                                                onChange={(e) => {
                                                                    const input = e.target;
                                                                    const cursorPos = input.selectionStart || 0;

                                                                    const { formatted, newCursor } = formatTireDimensionWithCursor(e.target.value, cursorPos);
                                                                    field.onChange(formatted);

                                                                    // Set cursor position after state update
                                                                    setTimeout(() => {
                                                                        input.setSelectionRange(newCursor, newCursor);
                                                                    }, 0);
                                                                }}
                                                                error={!!errors.tyreDimension}
                                                                helperText={errors.tyreDimension ? errors.tyreDimension.message : ''}
                                                                sx={
                                                                    viewOnly || disabledFields.includes('partNumber')
                                                                        ? MuiDisabledTextField
                                                                        : MuiTextFieldWithFocus
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </Stack>
                                            </Grid>
                                        )}

                                        <Grid item xs={12} sm={6} xl={3.5}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    className="label--500"
                                                    style={{
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    {togglePartType === PART_TYPES.PARTS ? 'Part Name' : 'Tire Name'}
                                                    <span style={{ color: '#D32F2F' }}> *</span>
                                                </Typography>

                                                <Controller
                                                    name="partName"
                                                    control={control}
                                                    rules={{
                                                        required: 'Part name is required',
                                                    }}
                                                    render={({ field }) => (
                                                        <ControlledAutocomplete
                                                            field={field}
                                                            name="part"
                                                            keyName="partName"
                                                            options={partsList}
                                                            inputValue={partsInput}
                                                            setInputValue={setPartsInput}
                                                            viewOnly={viewOnly || disabledFields.includes('partName')}
                                                            loading={partsModalLoading.fetch}
                                                            styles={{
                                                                active: MuiAutocompleteWithFocus,
                                                                disabled: MuiDisabledAutocomplete,
                                                            }}
                                                            errors={errors}
                                                            setValue={setValue}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={6} xl={3.5}>
                                            <Stack spacing={1}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        className="label--500"
                                                        style={{
                                                            letterSpacing: '0.15px',
                                                        }}
                                                    >
                                                        Supplier
                                                        {/* <span style={{ color: "#D32F2F" }}> *</span> */}
                                                    </Typography>
                                                    {!viewOnly && (
                                                        <Typography
                                                            variant="body1"
                                                            color={'primary'}
                                                            style={{
                                                                fontWeight: 500,
                                                                fontSize: '13px',

                                                                textTransform: 'uppercase',
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                if (getValues()?.supplierId) {
                                                                    navigate(`/suppliers/${getValues().supplierId}`);
                                                                } else {
                                                                    navigate('/suppliers/');
                                                                }
                                                            }}
                                                        >
                                                            View Supplier{' '}
                                                        </Typography>
                                                    )}
                                                </div>
                                                <Controller
                                                    name="supplierId"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            disabled={
                                                                viewOnly ||
                                                                type === INVENTORY_TYPES.SUPPLIER ||
                                                                type === INVENTORY_TYPES.SUPPLIER_INVOICE ||
                                                                disabledFields.includes('supplierId')
                                                            }
                                                            freeSolo
                                                            forcePopupIcon
                                                            clearIcon={<ClearRounded fontSize="small" />}
                                                            id="supplier-autocomplete"
                                                            onBlur={() => {
                                                                if (!field.value || !getValues().supplierId) {
                                                                    setValue('supplierInvoiceNumber', undefined);
                                                                    field.onChange('');
                                                                    setSupplierInput('');
                                                                }
                                                            }}
                                                            options={
                                                                supplierList?.length > 0
                                                                    ? !supplierInput ||
                                                                      supplierList.some(
                                                                          (item) => item.name?.toLowerCase() === supplierInput?.trim()?.toLowerCase()
                                                                      )
                                                                        ? supplierList
                                                                        : [{ _id: 'new', name: supplierInput }, ...supplierList]
                                                                    : supplierInput
                                                                      ? [{ _id: 'new', name: supplierInput }]
                                                                      : []
                                                            }
                                                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                                                            value={(supplierList?.length > 0 && supplierList.find((item) => item._id === field.value)) || null}
                                                            ListboxProps={{
                                                                style: { maxHeight: '280px' },
                                                            }}
                                                            inputValue={supplierInput}
                                                            onChange={(event, newValue) => {
                                                                if (newValue && newValue._id !== 'new') {
                                                                    field.onChange(newValue._id);
                                                                } else {
                                                                    setSupplierInvoiceList([]);
                                                                    setValue('supplierInvoiceNumber', null);
                                                                    setInvoiceInput('');
                                                                    clearErrors('supplierInvoiceNumber');
                                                                    field.onChange(null);
                                                                }
                                                            }}
                                                            onInputChange={(event, newInputValue) => {
                                                                const trimmedValue = newInputValue.trimStart();

                                                                setSupplierName(trimmedValue);
                                                                setSupplierInput(trimmedValue);
                                                                if (!supplierList.some((option) => option.name === trimmedValue)) {
                                                                    field.onChange(null);
                                                                }
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();

                                                                    const highlightedOption = document.querySelector('li.MuiAutocomplete-option.Mui-focused');
                                                                    const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();
                                                                    // Convert input to lowercase for case-insensitive comparison
                                                                    const inputLowerCase = supplierInput.trim().toLowerCase();

                                                                    // Filter options that match input (case-insensitive)
                                                                    const filteredOptions = supplierList.filter((option) =>
                                                                        option.name.toLowerCase().includes(optionText || inputLowerCase)
                                                                    );

                                                                    // Exact match option
                                                                    const exactMatch = supplierList.find(
                                                                        (option) => option.name.toLowerCase() === (optionText || inputLowerCase)
                                                                    );

                                                                    if (exactMatch) {
                                                                        // If there's an exact match, select it
                                                                        setTimeout(() => {
                                                                            setValue('supplierId', exactMatch._id);
                                                                        }, [200]);
                                                                        setSupplierInput(exactMatch.name);

                                                                        // Close dropdown after selection
                                                                        // setTimeout(() => document.activeElement.blur(), 0);
                                                                    } else if (inputLowerCase) {
                                                                        // If no exact match and input is not empty, open modal to save new category
                                                                        setOpenAddSupplierModal(true);
                                                                    } else if (filteredOptions.length > 0) {
                                                                        // If input is empty, select the first filtered option
                                                                        const firstOption = filteredOptions[0];
                                                                        field.onChange(firstOption._id);
                                                                        setSupplierInput(firstOption.name);

                                                                        // Close dropdown after selection
                                                                        setTimeout(() => document.activeElement.blur(), 0);
                                                                    }
                                                                }
                                                            }}
                                                            renderOption={(props, option) =>
                                                                option._id === 'new' ? (
                                                                    <li
                                                                        key={`temp-${option.name}-${Math.random()}`}
                                                                        {...props}
                                                                        style={{
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            height: '44px',
                                                                            paddingRight: '0',
                                                                        }}
                                                                    >
                                                                        <span>{supplierInput}</span>
                                                                        <Button
                                                                            size="small"
                                                                            color="primary"
                                                                            style={{
                                                                                background: '#2196F326',
                                                                                width: '80px',
                                                                            }}
                                                                            startIcon={!loading && <Save color="#006CDD" />}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenAddSupplierModal(true);
                                                                            }}
                                                                        >
                                                                            {loading ? <CircularProgress disableShrink size={20} /> : 'Save'}
                                                                        </Button>
                                                                    </li>
                                                                ) : (
                                                                    <li key={option._id} {...props} style={{ height: '44px' }}>
                                                                        {option.name}
                                                                    </li>
                                                                )
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={!!errors.supplierId}
                                                                    helperText={errors.supplierId ? errors.supplierId.message : ''}
                                                                    sx={
                                                                        viewOnly ||
                                                                        type === INVENTORY_TYPES.SUPPLIER ||
                                                                        type === INVENTORY_TYPES.SUPPLIER_INVOICE ||
                                                                        disabledFields.includes('supplierId')
                                                                            ? MuiDisabledAutocomplete
                                                                            : MuiAutocompleteWithFocus
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        {/* SupplierInvoiceField  */}
                                        <Grid item xs={12} sm={6} xl={3}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="body1"
                                                    className="label--500"
                                                    style={{
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    Supplier Invoice #{(supplierId || getValues().supplierId) && <span style={{ color: '#D32F2F' }}> *</span>}
                                                </Typography>
                                                <Controller
                                                    name="supplierInvoiceNumber"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <ControlledAutocomplete
                                                            name="invoice-number"
                                                            keyName="invoiceNumber"
                                                            errorName="supplierInvoiceNumber"
                                                            field={field}
                                                            inputValue={supplierInvoiceNumber || invoiceInput}
                                                            setInputValue={setInvoiceInput}
                                                            loading={feeModalLoading.fetch}
                                                            viewOnly={
                                                                !watchSupplierId ||
                                                                viewOnly ||
                                                                type === INVENTORY_TYPES.SUPPLIER_INVOICE ||
                                                                disabledFields.includes('supplierInvoiceNumber')
                                                            }
                                                            options={supplierInvoiceList}
                                                            styles={{
                                                                active: MuiAutocompleteWithFocus,
                                                                disabled: MuiDisabledAutocomplete,
                                                            }}
                                                            errors={errors}
                                                            setValue={setValue}
                                                            onInputChange={(event, trimmedValue) => {
                                                                setInvoiceInput(trimmedValue);
                                                                // setIsUsedInCustomerInvoice(false);
                                                                field.onChange(trimmedValue);
                                                                const find = supplierInvoiceList?.find(
                                                                    (opt) => opt?.invoiceNumber?.toLowerCase() === trimmedValue?.toLowerCase()
                                                                );
                                                                setValue('sold', find?.sold || 0);
                                                                setIsUsedInCustomerInvoice(find?.isUsedInCustomerInvoice || false);
                                                            }}
                                                            onChange={(event, newValue) => {
                                                                if (
                                                                    typeof newValue === 'string' &&
                                                                    supplierInvoiceList.find(
                                                                        (option) => option.invoiceNumber.toLowerCase() === newValue.toLowerCase()
                                                                    )
                                                                ) {
                                                                    // Existing invoice selected
                                                                } else if (newValue && newValue._id !== 'new') {
                                                                    setValue('sold', newValue?.sold || 0);
                                                                    setIsUsedInCustomerInvoice(newValue?.isUsedInCustomerInvoice || false);
                                                                    if (newValue?.parts?.length > 0) {
                                                                        const part = newValue.parts[newValue?.parts.length - 1];

                                                                        part.invoiceNumber = newValue?.invoiceNumber;
                                                                        setValue('cost', part.cost);

                                                                        const pricingMethod = part?.pricingMethod;
                                                                        setValue('pricingMethod', pricingMethod);

                                                                        let finalQty = getValues().qty;
                                                                        let finalCost = Number(part.cost || 0);
                                                                        let finalRetailPrice = Number(getValues().retailPrice);
                                                                        let finalFee = Number(getValues().feeAmount);

                                                                        // if (part.pricingMethod === 'margin') {
                                                                        //     setValue('pricingMethod', 'margin');
                                                                        // } else if (part.pricingMethod === 'markup') {
                                                                        //     setValue('pricingMethod', 'markup');
                                                                        // }

                                                                        // Use effective quantity for calculations when opened from invoice
                                                                        const effectiveQtyForSupplierInvoice =
                                                                            showUsedInInvoiceFeild &&
                                                                            type === INVENTORY_TYPES.INVOICE &&
                                                                            isUsedInvoiceQty !== null &&
                                                                            isUsedInvoiceQty !== undefined
                                                                                ? Number(isUsedInvoiceQty || 0)
                                                                                : finalQty;

                                                                        if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                                                                            calculateRetailPriceChange(
                                                                                finalRetailPrice,
                                                                                effectiveQtyForSupplierInvoice,
                                                                                finalCost,
                                                                                finalFee
                                                                            );
                                                                        }

                                                                        if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                                                                            calculateMarginChange(
                                                                                finalRetailPrice,
                                                                                effectiveQtyForSupplierInvoice,
                                                                                finalCost,
                                                                                finalFee
                                                                            );
                                                                        }

                                                                        if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                                                                            calculateMarkupChange(
                                                                                finalRetailPrice,
                                                                                effectiveQtyForSupplierInvoice,
                                                                                finalCost,
                                                                                finalFee
                                                                            );
                                                                        }

                                                                        // setValue('markupOrMarginPercentage', part?.markupOrMarginPercentage);
                                                                        setAlreadyExistSupplierData(part);
                                                                    }
                                                                    field.onChange(newValue.invoiceNumber);
                                                                } else {
                                                                    setValue('sold', newValue?.sold || 0);
                                                                    setIsUsedInCustomerInvoice(false);
                                                                    field.onChange(null);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Grid>
                                        {isAdditionalVisible && (
                                            <>
                                                <Grid item xs={12} sm={6} xl={3.5}>
                                                    <Stack spacing={1}>
                                                        <Typography variant="body1" className="label--500">
                                                            Brand
                                                        </Typography>
                                                        <Controller
                                                            name="partsBrand"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <ControlledAutocomplete
                                                                    field={field}
                                                                    name="brand"
                                                                    keyName="name"
                                                                    options={partsBrandList}
                                                                    inputValue={brandInput}
                                                                    setInputValue={setBrandInput}
                                                                    viewOnly={viewOnly}
                                                                    loading={brandModalLoading.fetch}
                                                                    styles={{
                                                                        active: MuiAutocompleteWithFocus,
                                                                        disabled: MuiDisabledAutocomplete,
                                                                    }}
                                                                    errors={errors}
                                                                    setValue={setValue}
                                                                />
                                                            )}
                                                        />
                                                    </Stack>
                                                </Grid>
                                                {/* //parcategoryField */}
                                                {togglePartType === PART_TYPES.PARTS && (
                                                    <Grid item xs={12} sm={6} xl={3.5}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                className="label--500"
                                                                style={{
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Category
                                                                {/* <span style={{ color: "#D32F2F" }}> *</span> */}
                                                            </Typography>
                                                            <Controller
                                                                name="partsCategory"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <ControlledAutocomplete
                                                                        field={field}
                                                                        name="category"
                                                                        keyName="name"
                                                                        options={partsCategoryList}
                                                                        inputValue={categoryInput}
                                                                        setInputValue={setCategoryInput}
                                                                        viewOnly={viewOnly}
                                                                        loading={categoryModalLoading.fetch}
                                                                        styles={{
                                                                            active: MuiAutocompleteWithFocus,
                                                                            disabled: MuiDisabledAutocomplete,
                                                                        }}
                                                                        errors={errors}
                                                                        setValue={setValue}
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}

                                                {/* //modal field */}
                                                {togglePartType === PART_TYPES.TYRE && (
                                                    <Grid item xs={12} sm={6} xl={3.5}>
                                                        <Stack spacing={1}>
                                                            <Typography variant="body1" className="label--500" style={{ letterSpacing: '0.15px' }}>
                                                                Model
                                                            </Typography>
                                                            <Controller
                                                                name="tyreModelId"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <ControlledAutocomplete
                                                                        field={field}
                                                                        name="model"
                                                                        keyName="name"
                                                                        options={tyreModalList}
                                                                        inputValue={tireModalInput}
                                                                        setInputValue={setTireModalInput}
                                                                        viewOnly={viewOnly}
                                                                        loading={tireModalLoading.fetch}
                                                                        styles={{
                                                                            active: MuiAutocompleteWithFocus,
                                                                            disabled: MuiDisabledAutocomplete,
                                                                        }}
                                                                        errors={errors}
                                                                        setValue={setValue}
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}

                                                {togglePartType === PART_TYPES.PARTS && (
                                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                className="label--500"
                                                                style={{
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Parts Provider
                                                            </Typography>
                                                            <Controller
                                                                name="partsProvider"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <RadioGroup
                                                                        {...field}
                                                                        row
                                                                        onChange={(value, newValue) => {
                                                                            if (!viewOnly) {
                                                                                setPartsProvider(newValue);
                                                                                field.onChange(newValue);
                                                                            }
                                                                        }}
                                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                                        name="controlled-radio-buttons-group"
                                                                        value={partsProvider}
                                                                        style={{ marginTop: '12px' }}
                                                                        sx={MuiDisabledRadioGroup}
                                                                    >
                                                                        <FormControlLabel
                                                                            disabled={viewOnly}
                                                                            value={PARTS_PROVIDER.OEM}
                                                                            control={<Radio />}
                                                                            label="OEM"
                                                                        />
                                                                        <FormControlLabel
                                                                            disabled={viewOnly}
                                                                            value={PARTS_PROVIDER.OES}
                                                                            control={<Radio />}
                                                                            label="OES"
                                                                        />
                                                                        <FormControlLabel
                                                                            disabled={viewOnly}
                                                                            value={PARTS_PROVIDER.AFTER_MARKET}
                                                                            control={<Radio />}
                                                                            label="After Market"
                                                                        />
                                                                        <FormControlLabel
                                                                            disabled={viewOnly}
                                                                            value={PARTS_PROVIDER.USED}
                                                                            control={<Radio />}
                                                                            label="Used"
                                                                        />
                                                                    </RadioGroup>
                                                                )}
                                                            />
                                                        </Stack>
                                                        {errors.partsProvider && <FormHelperText error>{errors.partsProvider.message}</FormHelperText>}
                                                    </Grid>
                                                )}

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={togglePartType === PART_TYPES.PARTS ? 12 : 5}
                                                    xl={togglePartType === PART_TYPES.PARTS ? 12 : 5}
                                                >
                                                    <Stack spacing={1}>
                                                        <Typography
                                                            variant="body1"
                                                            className="label--500"
                                                            style={{
                                                                letterSpacing: '0.15px',
                                                            }}
                                                        >
                                                            Description
                                                        </Typography>
                                                        <Controller
                                                            name="description"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    disabled={viewOnly}
                                                                    {...field}
                                                                    id="outlined-basic"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    sx={viewOnly ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                />
                                                            )}
                                                        />
                                                    </Stack>
                                                </Grid>
                                            </>
                                        )}
                                        <Grid
                                            item
                                            container
                                            direction="row"
                                            spacing={0}
                                            xs={12}
                                            style={{ borderTop: '1px solid   #0000001F', paddingTop: '0', marginTop: '24px' }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                lg={2}
                                                container
                                                rowSpacing={3}
                                                columnSpacing={'20px'}
                                                style={
                                                    isMdUp
                                                        ? { paddingBottom: '24px', maxHeight: 'max-content' }
                                                        : { paddingTop: '24px', maxHeight: 'max-content' }
                                                } // optional: spacing when divider hidden
                                            >
                                                <Grid item xs={12}>
                                                    <Typography
                                                        fontWeight={500}
                                                        fontSize={'24px'}
                                                        color={'#000000DE'}
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                        pt={3}
                                                    >
                                                        <div style={{ width: '32px', height: '32px', marginRight: '4px' }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                                <path
                                                                    d="M29.3241 10.6C29.3215 10.5038 29.3086 10.4081 29.2854 10.3147C29.2761 10.2814 29.2574 10.2494 29.2454 10.216C29.2174 10.14 29.1921 10.0654 29.1521 9.99603C29.1307 9.96003 29.1014 9.93069 29.0761 9.89603C29.0334 9.83603 28.9921 9.77469 28.9401 9.72269C28.9094 9.69336 28.8694 9.66936 28.8361 9.64136C28.7841 9.59869 28.7361 9.55203 28.6761 9.51603L28.6574 9.50803L28.6467 9.50003L16.6747 2.84669C16.477 2.73675 16.2545 2.67894 16.0283 2.67871C15.802 2.67848 15.5794 2.73583 15.3814 2.84536L3.35341 9.49869C3.34986 9.50314 3.34497 9.50758 3.33875 9.51203L3.32541 9.51736C3.27875 9.54403 3.24408 9.58269 3.20008 9.61469C3.15208 9.65069 3.10141 9.68269 3.05875 9.72403C3.01875 9.76536 2.98808 9.81336 2.95341 9.86003C2.91875 9.90669 2.87741 9.94803 2.84808 9.99869C2.81341 10.056 2.79475 10.1214 2.76941 10.184C2.75075 10.228 2.72675 10.2694 2.71475 10.3174C2.69197 10.4091 2.67901 10.5029 2.67608 10.5974C2.67475 10.62 2.66675 10.64 2.66675 10.664V21.3334C2.66675 21.8174 2.92941 22.264 3.35341 22.4987L15.3241 29.148L15.3254 29.1494L15.3281 29.1507L15.3547 29.1654C15.4121 29.1974 15.4747 29.2147 15.5347 29.2374C15.5774 29.2547 15.6187 29.2774 15.6641 29.2894C15.8853 29.3472 16.1176 29.3472 16.3387 29.2894C16.3827 29.2774 16.4241 29.2547 16.4681 29.2374C16.5281 29.2147 16.5907 29.1987 16.6481 29.1654L16.6747 29.1507L16.6774 29.1494L16.6787 29.148L28.6494 22.4987C29.0707 22.264 29.3334 21.8174 29.3334 21.3334V10.664C29.3334 10.6414 29.3254 10.6227 29.3241 10.6ZM15.9627 15.8294L6.74408 10.6734L10.4267 8.63603L19.5387 13.8427L15.9627 15.8294ZM16.0267 5.53736L25.2547 10.6667L22.2627 12.3294L13.1561 7.12536L16.0267 5.53736ZM17.3334 25.7347L17.3361 18.1627L21.3334 15.9254V20L24.0001 18.6667V14.4334L26.6667 12.9414V20.548L17.3334 25.7347Z"
                                                                    fill="#2196F3"
                                                                />
                                                            </svg>
                                                        </div>
                                                        Stock
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6} lg={12}>
                                                    <Stack spacing={1}>
                                                        <Typography
                                                            variant="body1"
                                                            style={{
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '24px',
                                                                letterSpacing: '0.15px',
                                                            }}
                                                        >
                                                            In Stock Quantity
                                                            <span style={{ color: '#D32F2F' }}> *</span>
                                                        </Typography>
                                                        <Controller
                                                            name="qty"
                                                            control={control}
                                                            rules={{
                                                                required: 'Quantity is required',
                                                                validate: (value) => {
                                                                    if (Number(value) === 0) {
                                                                        return 'Quantity cannot be 0';
                                                                    }

                                                                    return true;
                                                                },
                                                            }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    inputRef={(el) => {
                                                                        qtyInputRef.current = el;
                                                                    }}
                                                                    disabled={viewOnly}
                                                                    fullWidth
                                                                    id="outlined-basic"
                                                                    variant="outlined"
                                                                    error={!!errors.qty}
                                                                    helperText={errors.qty ? errors.qty.message : ''}
                                                                    value={field.value}
                                                                    onChange={(event) => {
                                                                        const inputValue = event.target.value;
                                                                        const numericValue = inputValue.replace(/[^\d.]/g, '');
                                                                        if (numericValue === '' || /^\d*(\.\d{0,1})?$/.test(numericValue)) {
                                                                            setValue('qty', numericValue);
                                                                            // When opened from invoice, use effectiveQty for calculations
                                                                            const qtyForCalc =
                                                                                showUsedInInvoiceFeild &&
                                                                                type === INVENTORY_TYPES.INVOICE &&
                                                                                isUsedInvoiceQty !== null &&
                                                                                isUsedInvoiceQty !== undefined
                                                                                    ? getEffectiveQty()
                                                                                    : numericValue || 0;

                                                                            if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                                                                                calculateMarginChange(
                                                                                    getValues().marginPercentage,
                                                                                    qtyForCalc,
                                                                                    getValues().cost
                                                                                );
                                                                            }

                                                                            if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                                                                                calculateMarkupChange(
                                                                                    getValues().markupPercentage,
                                                                                    qtyForCalc,
                                                                                    getValues().cost
                                                                                );
                                                                            }

                                                                            if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                                                                                calculateRetailPriceChange(
                                                                                    getValues().retailPrice,
                                                                                    qtyForCalc,
                                                                                    getValues().cost
                                                                                );
                                                                            }

                                                                            if (numericValue == '') {
                                                                                setError('qty', {
                                                                                    type: 'manual',
                                                                                    message: 'Quantity is required',
                                                                                });
                                                                            } else if (numericValue == 0) {
                                                                                setError('qty', {
                                                                                    type: 'manual',
                                                                                    message: 'Quantity cannot be 0',
                                                                                });
                                                                            } else {
                                                                                clearErrors('qty');
                                                                            }
                                                                        }
                                                                    }}
                                                                    sx={viewOnly ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                />
                                                            )}
                                                        />
                                                    </Stack>
                                                </Grid>
                                                {showUsedInInvoiceFeild ? (
                                                    <Grid item xs={12} sm={6} lg={12}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                {FeildLabelName}
                                                            </Typography>
                                                            <TextField
                                                                value={isUsedInvoiceQty}
                                                                inputRef={(el) => {
                                                                    qtyInputRef.current = el;
                                                                }}
                                                                disabled={viewOnly}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                variant="outlined"
                                                                sx={viewOnly ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                onChange={(event) => {
                                                                    const inputValue = event.target.value;
                                                                    const numericValue = inputValue.replace(/[^\d.]/g, '');
                                                                    if (numericValue === '' || /^\d*(\.\d{0,1})?$/.test(numericValue)) {
                                                                        if (Number(numericValue) <= Number(getValues().qty)) {
                                                                            setIsUsedInvoiceQty(numericValue);
                                                                            // Update billedQty to match isUsedInvoiceQty when opened from invoice
                                                                            if (showUsedInInvoiceFeild && type === INVENTORY_TYPES.INVOICE) {
                                                                                setValue('billedQty', Number(numericValue || 0));

                                                                                // Recalculate all summary values based on current pricing method
                                                                                const cost = Number(getValues().cost || 0);
                                                                                const fee = Number(getValues().feeAmount || 0);
                                                                                const effectiveQty = Number(numericValue || 0);

                                                                                if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                                                                                    calculateRetailPriceChange(
                                                                                        getValues().retailPrice,
                                                                                        effectiveQty,
                                                                                        cost,
                                                                                        fee
                                                                                    );
                                                                                } else if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                                                                                    calculateMarginChange(
                                                                                        getValues().marginPercentage,
                                                                                        effectiveQty,
                                                                                        cost,
                                                                                        fee
                                                                                    );
                                                                                } else if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                                                                                    calculateMarkupChange(
                                                                                        getValues().markupPercentage,
                                                                                        effectiveQty,
                                                                                        cost,
                                                                                        fee
                                                                                    );
                                                                                }
                                                                            }
                                                                        } else {
                                                                            toast.error('Used In Invoice should be less than or equal to stock quantity');
                                                                        }
                                                                    }
                                                                }}
                                                                // error={!!errors.qty}
                                                                // helperText={errors.qty ? errors.qty.message : ''}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                ) : (
                                                    <Grid item xs={12} sm={6} lg={12}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                {FeildLabelName}
                                                            </Typography>
                                                            <Controller
                                                                name="sold"
                                                                control={control}
                                                                render={({ field }) =>
                                                                    isUsedInCustomerInvoice ? (
                                                                        <HtmlTooltip
                                                                            title={
                                                                                <React.Fragment>
                                                                                    <span>Click below to view the invoices in which this part was used. </span>

                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        style={{
                                                                                            textTransform: 'uppercase',
                                                                                            fontSize: 12,
                                                                                            marginTop: 11,
                                                                                            height: '28px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            padding: '0 8px',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setPartInvoiceModal(true);
                                                                                        }}
                                                                                    >
                                                                                        View invoice list
                                                                                    </Button>
                                                                                </React.Fragment>
                                                                            }
                                                                            placement="bottom"
                                                                            arrow
                                                                        >
                                                                            {renderUsedInvoiceQty(field)}
                                                                        </HtmlTooltip>
                                                                    ) : (
                                                                        renderUsedInvoiceQty(field)
                                                                    )
                                                                }
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            {isMdUp && (
                                                <Grid item style={{ width: '48px', display: 'flex', justifyContent: 'center' }}>
                                                    <Divider
                                                        style={{
                                                            background: '#0000001F',
                                                            width: '1px',
                                                            height: '100%',
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid
                                                item
                                                xs={12}
                                                lg={6}
                                                container
                                                rowSpacing={3}
                                                columnSpacing={'20px'}
                                                style={
                                                    isMdUp ? { paddingBottom: '24px', height: 'max-content' } : { paddingTop: '24px', height: 'max-content' }
                                                } // optional: spacing when divider hidden
                                            >
                                                <Grid item xs={12} style={{ maxHeight: 'max-content' }}>
                                                    <Typography
                                                        fontWeight={500}
                                                        fontSize={'24px'}
                                                        color={'#000000DE'}
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                        pt={3}
                                                    >
                                                        <div style={{ width: '32px', height: '32px', marginRight: '4px' }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                                <path
                                                                    d="M4 8H28V24H4V8ZM16 12C17.0609 12 18.0783 12.4214 18.8284 13.1716C19.5786 13.9217 20 14.9391 20 16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20C14.9391 20 13.9217 19.5786 13.1716 18.8284C12.4214 18.0783 12 17.0609 12 16C12 14.9391 12.4214 13.9217 13.1716 13.1716C13.9217 12.4214 14.9391 12 16 12ZM9.33333 10.6667C9.33333 11.3739 9.05238 12.0522 8.55229 12.5523C8.05219 13.0524 7.37391 13.3333 6.66667 13.3333V18.6667C7.37391 18.6667 8.05219 18.9476 8.55229 19.4477C9.05238 19.9478 9.33333 20.6261 9.33333 21.3333H22.6667C22.6667 20.6261 22.9476 19.9478 23.4477 19.4477C23.9478 18.9476 24.6261 18.6667 25.3333 18.6667V13.3333C24.6261 13.3333 23.9478 13.0524 23.4477 12.5523C22.9476 12.0522 22.6667 11.3739 22.6667 10.6667H9.33333Z"
                                                                    fill="#2196F3"
                                                                />
                                                            </svg>
                                                        </div>
                                                        Pricing
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} style={{ maxHeight: 'max-content' }}>
                                                    <Stack spacing={1}>
                                                        <Typography
                                                            variant="body1"
                                                            style={{
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '24px',
                                                                letterSpacing: '0.15px',
                                                            }}
                                                        >
                                                            Cost Per Unit
                                                            <span style={{ color: '#D32F2F' }}> *</span>
                                                        </Typography>
                                                        <Controller
                                                            name="cost"
                                                            control={control}
                                                            rules={{
                                                                required: 'Cost Per Unit is required',
                                                                validate: (value) => {
                                                                    if (value === '.') {
                                                                        return 'Cost cannot be just a decimal point.';
                                                                    }
                                                                    if (Number(value) === 0) {
                                                                        return 'Cost cannot be 0';
                                                                    }

                                                                    return true;
                                                                },
                                                            }}
                                                            render={({ field }) =>
                                                                isUsedInCustomerInvoice ? (
                                                                    <HtmlTooltip
                                                                        title={
                                                                            <React.Fragment>
                                                                                <span>This part is connected with a customer invoice and not editable.</span>

                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    style={{
                                                                                        textTransform: 'uppercase',
                                                                                        fontSize: 12,
                                                                                        marginTop: 11,
                                                                                        height: '28px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        padding: '0 8px',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        setPartInvoiceModal(true);
                                                                                    }}
                                                                                >
                                                                                    View Customer Invoice
                                                                                </Button>
                                                                            </React.Fragment>
                                                                        }
                                                                        placement="bottom"
                                                                        arrow
                                                                    >
                                                                        {renderTextField(field)}
                                                                    </HtmlTooltip>
                                                                ) : (
                                                                    renderTextField(field)
                                                                )
                                                            }
                                                        />
                                                    </Stack>
                                                </Grid>

                                                <Grid item container rowSpacing={3} columnSpacing={'20px'}>
                                                    {orderedPriceTypes.map((type) => {
                                                        return <React.Fragment key={type}>{PRICE_BLOCKS[type]?.()}</React.Fragment>;
                                                    })}
                                                </Grid>

                                                {/* Manual Price  */}
                                                {/* <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
                                                    <Stack spacing={1}>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <Radio
                                                                checked={getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE}
                                                                onChange={(event) => {
                                                                    if (event.target.checked) {
                                                                        setValue('pricingMethod', PRICING_METHOD.RETAIL_PRICE);
                                                                        const qty = Number(getValues().qty || 0);
                                                                        const cost = Number(getValues().cost || 0);

                                                                        calculateRetailPriceChange(getValues().retailPrice, qty, cost);
                                                                    }
                                                                }}
                                                                value="retailPrice"
                                                                disabled={viewOnly}
                                                                size="small"
                                                                sx={{
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: '1.25rem',
                                                                    },
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Manual price<span style={{ color: '#D32F2F' }}> *</span>
                                                            </Typography>
                                                        </Stack>

                                                        <Controller
                                                            name="retailPrice"
                                                            control={control}
                                                            render={({ field }) => {
                                                                const retailPriceWatched = watch('retailPrice');
                                                                const costWatched = watch('cost');
                                                                const qtyWatched = watch('qty');

                                                                const currentValue = retailPriceWatched || field.value;
                                                                const displayValue = viewOnly
                                                                    ? NumericEngine.format(currentValue || 0, { trailingZeros: true, formatCurrency: true })
                                                                    : getValues('pricingMethod') === PRICING_METHOD.RETAIL_PRICE
                                                                      ? currentValue
                                                                      : NumericEngine.format(currentValue || 0, { trailingZeros: true, formatCurrency: true });

                                                                return (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={displayValue}
                                                                        disabled={viewOnly || getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE}
                                                                        sx={
                                                                            viewOnly || getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE
                                                                                ? MuiDisabledTextField
                                                                                : MuiTextFieldWithFocus
                                                                        }
                                                                        onChange={(event) => {
                                                                            const inputValue = event.target.value;
                                                                            const numericValue = inputValue.replace(/[^\d.]/g, '');

                                                                            if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                                                                const qty = Number(qtyWatched || getValues().qty || 0);
                                                                                const cost = Number(costWatched || getValues().cost || 0);

                                                                                calculateRetailPriceChange(numericValue, qty, cost);
                                                                            }
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment:
                                                                                viewOnly ||
                                                                                isUsedInCustomerInvoice ||
                                                                                getValues('pricingMethod') !== PRICING_METHOD.RETAIL_PRICE ? null : (
                                                                                    <p
                                                                                        style={{
                                                                                            paddingLeft: '0',
                                                                                        }}
                                                                                    >
                                                                                        $
                                                                                    </p>
                                                                                ),
                                                                        }}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </Stack>
                                                </Grid> */}

                                                {/* Margin Percentage  */}
                                                {/* <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
                                                    <Stack spacing={1}>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <Radio
                                                                checked={getValues().pricingMethod === PRICING_METHOD.MARGIN}
                                                                onChange={(event) => {
                                                                    if (event.target.checked) {
                                                                        setValue('pricingMethod', PRICING_METHOD.MARGIN);

                                                                        const qty = Number(getValues().qty || 0);
                                                                        const cost = Number(getValues().cost || 0);

                                                                        calculateMarginChange(getValues().marginPercentage, qty, cost);
                                                                    }
                                                                }}
                                                                value="marginPercentage"
                                                                disabled={viewOnly}
                                                                size="small"
                                                                sx={{
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: '1.25rem',
                                                                    },
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Margin %<span style={{ color: '#D32F2F' }}> *</span>
                                                            </Typography>
                                                        </Stack>

                                                        <Controller
                                                            name="marginPercentage"
                                                            control={control}
                                                            render={({ field }) => {
                                                                const marginPercentageWatched = watch('marginPercentage');
                                                                const costWatched = watch('cost');
                                                                const qtyWatched = watch('qty');

                                                                const currentValue = marginPercentageWatched || field.value;
                                                                const isDisabled = viewOnly || getValues('pricingMethod') !== PRICING_METHOD.MARGIN;
                                                                const formattedValue = viewOnly
                                                                    ? NumericEngine.format(currentValue, { trailingZeros: true })
                                                                    : getValues('pricingMethod') === PRICING_METHOD.MARGIN
                                                                      ? currentValue
                                                                      : NumericEngine.format(currentValue, { trailingZeros: true });

                                                                const displayValue = isDisabled ? `${formattedValue}%` : formattedValue;

                                                                return (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={displayValue}
                                                                        disabled={isDisabled}
                                                                        onChange={(event) => {
                                                                            const inputValue = event.target.value;
                                                                            const numericValue = inputValue.replace(/[^\d.]/g, '');

                                                                            if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                                                                const qty = Number(qtyWatched || getValues().qty || 0);
                                                                                const cost = Number(costWatched || getValues().cost || 0);

                                                                                calculateMarginChange(numericValue, qty, cost);
                                                                            }
                                                                        }}
                                                                        sx={isDisabled ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </Stack>
                                                </Grid> */}

                                                {/* Markup Percentage  */}
                                                {/* <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
                                                    <Stack spacing={1}>
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <Radio
                                                                checked={getValues().pricingMethod === PRICING_METHOD.MARKUP}
                                                                onChange={(event) => {
                                                                    if (event.target.checked) {
                                                                        setValue('pricingMethod', PRICING_METHOD.MARKUP);

                                                                        const qty = Number(getValues().qty || 0);
                                                                        const cost = Number(getValues().cost || 0);

                                                                        calculateMarkupChange(getValues().markupPercentage, qty, cost);
                                                                    }
                                                                }}
                                                                value="markupPercentage"
                                                                disabled={viewOnly}
                                                                size="small"
                                                                sx={{
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: '1.25rem',
                                                                    },
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Markup %<span style={{ color: '#D32F2F' }}> *</span>
                                                            </Typography>
                                                        </Stack>

                                                        <Controller
                                                            name="markupPercentage"
                                                            control={control}
                                                            render={({ field }) => {
                                                                const markupPercentageWatched = watch('markupPercentage');
                                                                const costWatched = watch('cost');
                                                                const qtyWatched = watch('qty');

                                                                const currentValue = markupPercentageWatched || field.value;
                                                                const isDisabled = viewOnly || getValues('pricingMethod') !== PRICING_METHOD.MARKUP;
                                                                const formattedValue = viewOnly
                                                                    ? NumericEngine.format(currentValue, { trailingZeros: true })
                                                                    : getValues('pricingMethod') === PRICING_METHOD.MARKUP
                                                                      ? currentValue
                                                                      : NumericEngine.format(currentValue, { trailingZeros: true });

                                                                const displayValue = isDisabled ? `${formattedValue}%` : formattedValue;

                                                                return (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={displayValue}
                                                                        disabled={isDisabled}
                                                                        onChange={(event) => {
                                                                            const inputValue = event.target.value;
                                                                            const numericValue = inputValue.replace(/[^\d.]/g, '');

                                                                            if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                                                                const qty = Number(qtyWatched || getValues().qty || 0);
                                                                                const cost = Number(costWatched || getValues().cost || 0);

                                                                                calculateMarkupChange(numericValue, qty, cost);
                                                                            }
                                                                        }}
                                                                        sx={isDisabled ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </Stack>
                                                </Grid> */}

                                                {/* Fee Type  */}
                                                {isFeeVisible && (
                                                    <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content', overflow: 'hidden' }}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                className="label--500"
                                                                style={{
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Fee type
                                                                <span style={{ color: '#D32F2F' }}> *</span>
                                                            </Typography>

                                                            <Controller
                                                                name={'feeName'}
                                                                control={control}
                                                                rules={{ required: 'Fee is required' }}
                                                                render={({ field }) => (
                                                                    <ControlledAutocomplete
                                                                        name="feeName"
                                                                        errorName="feeName"
                                                                        field={field}
                                                                        options={feesList}
                                                                        inputValue={feeInput}
                                                                        setInputValue={setfeeInput}
                                                                        viewOnly={viewOnly}
                                                                        loading={feeModalLoading.fetch}
                                                                        styles={{
                                                                            active: MuiAutocompleteWithFocus,
                                                                            disabled: MuiDisabledAutocomplete,
                                                                        }}
                                                                        errors={errors}
                                                                        setValue={setValue}
                                                                        onChange={(event, newValue) => {
                                                                            const selectedName = newValue?.name ?? '';
                                                                            field.onChange(selectedName);

                                                                            const matchedOption = feesList.find(
                                                                                (opt) => opt.name.toLowerCase() === selectedName.toLowerCase()
                                                                            );

                                                                            if (matchedOption && setValue) {
                                                                                setValue('feeAmount', matchedOption.amount?.toString() ?? '0');
                                                                                if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                                                                                    calculateRetailPriceChange(
                                                                                        getValues().retailPrice,
                                                                                        getValues().qty,
                                                                                        getValues().cost
                                                                                    );
                                                                                }
                                                                                if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                                                                                    calculateMarginChange(
                                                                                        getValues().retailPrice,
                                                                                        getValues().qty,
                                                                                        getValues().cost
                                                                                    );
                                                                                }
                                                                                if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                                                                                    calculateMarkupChange(
                                                                                        getValues().retailPrice,
                                                                                        getValues().qty,
                                                                                        getValues().cost
                                                                                    );
                                                                                }
                                                                            } else if (setValue) {
                                                                                setValue('feeAmount', '0');
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}

                                                {/* Fee Per Unit  */}
                                                {isFeeVisible && (
                                                    <Grid item xs={12} sm={6} md={4} xl={4} style={{ maxHeight: 'max-content' }}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Fee Per Unit
                                                                <span style={{ color: '#D32F2F' }}> *</span>
                                                            </Typography>
                                                            <Controller
                                                                name="feeAmount"
                                                                control={control}
                                                                rules={{
                                                                    required: 'Fee is required',
                                                                    validate: (value) => {
                                                                        if (value === '.') {
                                                                            return 'Fee cannot be just a decimal point.';
                                                                        }
                                                                        if (Number(value) === 0) {
                                                                            return 'Fee cannot be 0';
                                                                        }

                                                                        return true;
                                                                    },
                                                                }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        disabled={viewOnly}
                                                                        error={!!errors.feeAmount}
                                                                        helperText={errors.feeAmount ? errors.feeAmount.message : ''}
                                                                        sx={viewOnly ? MuiDisabledTextField : MuiTextFieldWithFocus}
                                                                        InputProps={{
                                                                            startAdornment: viewOnly ? null : <p style={{ paddingLeft: '0' }}>$</p>,
                                                                        }}
                                                                        value={viewOnly ? formatCurrency(field.value) : truncateToFixed(field.value)}
                                                                        onChange={(event) => {
                                                                            const inputValue = event.target.value;
                                                                            const numericValue = inputValue.replace(/[^\d.]/g, '');
                                                                            if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
                                                                                setValue('feeAmount', numericValue);

                                                                                if (getValues().pricingMethod === PRICING_METHOD.MARGIN) {
                                                                                    calculateMarginChange(
                                                                                        getValues().marginPercentage,
                                                                                        getValues().qty,
                                                                                        getValues().cost,
                                                                                        numericValue || 0
                                                                                    );
                                                                                }

                                                                                if (getValues().pricingMethod === PRICING_METHOD.MARKUP) {
                                                                                    calculateMarkupChange(
                                                                                        getValues().markupPercentage,
                                                                                        getValues().qty,
                                                                                        getValues().cost,
                                                                                        numericValue || 0
                                                                                    );
                                                                                }

                                                                                if (getValues().pricingMethod === PRICING_METHOD.RETAIL_PRICE) {
                                                                                    calculateRetailPriceChange(
                                                                                        getValues().retailPrice,
                                                                                        getValues().qty,
                                                                                        getValues().cost,
                                                                                        numericValue || 0
                                                                                    );
                                                                                }
                                                                                if (numericValue == '') {
                                                                                    setError('feeAmount', {
                                                                                        type: 'manual',
                                                                                        message: 'Fee is required',
                                                                                    });
                                                                                } else if (numericValue == 0) {
                                                                                    setError('feeAmount', {
                                                                                        type: 'manual',
                                                                                        message: 'Fee cannot be 0',
                                                                                    });
                                                                                } else {
                                                                                    clearErrors('feeAmount');
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}

                                                {/* Total Fee  */}
                                                {isFeeVisible && (
                                                    <Grid item xs={11} sm={5} md={3} xl={3} style={{ maxHeight: 'max-content' }}>
                                                        <Stack spacing={1}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                }}
                                                            >
                                                                Total Fee
                                                            </Typography>
                                                            <Controller
                                                                name="totalFee"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        fullWidth
                                                                        {...field}
                                                                        value={formatCurrency(field.value)}
                                                                        disabled
                                                                        sx={MuiDisabledTextField}
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                )}

                                                {!viewOnly && isFeeVisible && (
                                                    <Grid
                                                        style={{
                                                            marginTop: '42px',
                                                            maxHeight: 'max-content',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            paddingLeft: '8px',
                                                        }}
                                                        item
                                                        xs={0.8}
                                                    >
                                                        <Delete
                                                            color="error"
                                                            sx={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setIsFeeVisible(false);
                                                                setfeeInput('');
                                                                setValue('feeAmount', 0);
                                                                setValue('feeName', '');
                                                            }}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>

                                            {isMdUp && (
                                                <Grid item style={{ width: '48px', display: 'flex', justifyContent: 'center' }}>
                                                    <Divider
                                                        style={{
                                                            background: '#0000001F',
                                                            width: '1px',
                                                            height: '100%',
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid
                                                item
                                                xs={12}
                                                lg={2.88}
                                                container
                                                rowSpacing={3}
                                                columnSpacing={'20px'}
                                                style={isMdUp ? { height: 'max-content' } : { marginBottom: '24px' }}
                                            >
                                                <Grid item xs={12} style={{ maxHeight: 'max-content' }}>
                                                    <Typography
                                                        fontWeight={500}
                                                        fontSize={'24px'}
                                                        color={'#000000DE'}
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                        pt={3}
                                                    >
                                                        <div style={{ width: '32px', height: '32px', marginRight: '4px' }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                                <path
                                                                    d="M27.9999 15.7981C28.0018 17.3476 27.7053 18.8823 27.1277 20.3138C26.55 21.7454 25.7025 23.0456 24.6338 24.1398L16.5085 15.7981V4C22.8541 3.999 27.9989 9.27931 27.9999 15.7939V15.7981Z"
                                                                    fill="#85C9FF"
                                                                />
                                                                <path
                                                                    d="M23.376 24.5875C18.9435 29.1381 11.7569 29.1381 7.32442 24.5875C2.89189 20.0369 2.89185 12.6589 7.32437 8.10828C8.37837 7.02619 9.62967 6.16785 11.0068 5.58225C12.3839 4.99665 13.8599 4.69527 15.3505 4.69531V16.3482L23.376 24.5875Z"
                                                                    fill="#2196F3"
                                                                />
                                                            </svg>
                                                        </div>
                                                        Summary
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={12} lg={12} style={{ maxHeight: 'max-content' }}>
                                                    <Stack
                                                        padding={'12px'}
                                                        gap={1}
                                                        sx={{
                                                            border: '1px solid #0000001F',
                                                            borderRadius: '8px',
                                                            boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
                                                        }}
                                                    >
                                                        {/* Quantity */}
                                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                {showUsedInInvoiceFeild
                                                                    ? 'Billed Qty'
                                                                    : type === INVENTORY_TYPES.SUPPLIER_INVOICE
                                                                      ? 'Received Stock Qty'
                                                                      : 'In Stock Qty'}
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                {showUsedInInvoiceFeild &&
                                                                type === INVENTORY_TYPES.INVOICE &&
                                                                isUsedInvoiceQty !== null &&
                                                                isUsedInvoiceQty !== undefined
                                                                    ? isUsedInvoiceQty || 0
                                                                    : showUsedInInvoiceFeild
                                                                      ? getValues()?.billedQty || 0
                                                                      : getValues()?.qty || 0}
                                                            </Typography>
                                                        </Stack>

                                                        {/* Price */}
                                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                Unit Price
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                {NumericEngine.format(getValues().retailPrice || 0, {
                                                                    trailingZeros: true,
                                                                    formatCurrency: true,
                                                                })}
                                                            </Typography>
                                                        </Stack>

                                                        {/* Divider */}
                                                        <Divider
                                                            sx={{
                                                                margin: '4px 0',
                                                                color: '#0000001F',
                                                                background: '#0000001F',
                                                            }}
                                                        />

                                                        {/* Total Price */}
                                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                {showUsedInInvoiceFeild ? 'Total Amount' : 'Total Value'}
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                            >
                                                                {NumericEngine.format(getValues().totalRetailPrice || 0, {
                                                                    trailingZeros: true,
                                                                    formatCurrency: true,
                                                                })}
                                                            </Typography>
                                                        </Stack>

                                                        {/* Total after Fees */}
                                                        {isFeeVisible && (
                                                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                                <Typography
                                                                    variant="body1"
                                                                    style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                                >
                                                                    Total after Fees
                                                                </Typography>
                                                                <Typography
                                                                    variant="body1"
                                                                    style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.15px' }}
                                                                >
                                                                    {NumericEngine.format(getValues().totalAfterFee || 0, {
                                                                        trailingZeros: true,
                                                                        formatCurrency: true,
                                                                    })}
                                                                </Typography>
                                                            </Stack>
                                                        )}

                                                        {/* Divider */}
                                                        {isFeeVisible && (
                                                            <Divider
                                                                sx={{
                                                                    margin: '4px 0',
                                                                    color: '#0000001F',
                                                                    background: '#0000001F',
                                                                }}
                                                            />
                                                        )}

                                                        {/* Total Profit */}
                                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 400,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                    color: '#2E7D32',
                                                                }}
                                                            >
                                                                Gross Profit
                                                            </Typography>
                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    fontWeight: 400,
                                                                    fontSize: '16px',
                                                                    lineHeight: '24px',
                                                                    letterSpacing: '0.15px',
                                                                    color: '#2E7D32',
                                                                }}
                                                            >
                                                                {NumericEngine.format(getValues().totalProfit || 0, {
                                                                    trailingZeros: true,
                                                                    formatCurrency: true,
                                                                })}
                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>

                                <div
                                    style={{
                                        // display: editModalTabvalue == 1 ? 'block' : 'none',
                                        display: 'none',
                                        width: '100%',
                                    }}
                                >
                                    <Grid item container spacing={3} alignItems={'center'}>
                                        <Grid item md={4.6}>
                                            <FormControl variant="standard" fullWidth>
                                                <InputLabel htmlFor="input-with-icon-adornment">Search field</InputLabel>
                                                <Input
                                                    placeholder="Search from inventory"
                                                    id="input-with-icon-adornment"
                                                    onChange={(event) => {
                                                        setInventroySearch(event.target.value);
                                                    }}
                                                    startAdornment={
                                                        <InputAdornment position="start">
                                                            <Search />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                fullWidth
                                                select
                                                id="standard-search"
                                                label="Filter"
                                                type="Search Category"
                                                placeholder="Search Category"
                                                value={partCategoryId}
                                                variant="standard"
                                                onChange={(event) => {
                                                    setPartCategoryId(event.target.value);
                                                }}
                                            >
                                                <MenuItem key={0} value={''}>
                                                    All
                                                </MenuItem>
                                                {partsCategoryList?.length > 0 &&
                                                    partsCategoryList.map((item, index) => (
                                                        <MenuItem key={index + 1} value={item._id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={2}>
                                            <TextField
                                                fullWidth
                                                select
                                                id="standard-search"
                                                label="Sort by"
                                                type="Sort by"
                                                // placeholder="stockLastPurchasedDate"
                                                value={order}
                                                variant="standard"
                                                onChange={(event) => {
                                                    setOrder(event.target.value);
                                                }}
                                            >
                                                <MenuItem key={0} value={'ASC'}>
                                                    Newest
                                                </MenuItem>
                                                <MenuItem key={0} value={'DESC'}>
                                                    Oldest
                                                </MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item md={2.3}>
                                            <FormControlLabel
                                                sx={{
                                                    width: '100%',
                                                    margin: 0,
                                                    justifyContent: 'end',
                                                }}
                                                control={<Checkbox defaultChecked={inventoryStatus} checked={inventoryStatus} />}
                                                label="Only In Stock"
                                                onChange={(value, newValue) => {
                                                    setInventoryStatus(newValue);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container mt={3.2}>
                                        <Typography fontWeight={500} fontSize={'20px'} color={'#000000DE'}>
                                            Recently Added Parts
                                        </Typography>
                                    </Grid>

                                    <Grid item container mt={1}>
                                        <TableContainer sx={{ maxHeight: 416 }}>
                                            <Table stickyHeader aria-label="caption table" style={{ padding: '16px' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            style={{
                                                                minWidth: '5px',
                                                                padding: '0',
                                                                background: '#F8F8F8',
                                                            }}
                                                        ></TableCell>

                                                        <TableCell sx={{ bgcolor: '#F8F8F8', minWidth: '205px' }}>Description</TableCell>
                                                        <TableCell sx={{ bgcolor: '#F8F8F8', minWidth: '205px' }}>Supplier / Brand</TableCell>
                                                        <TableCell sx={{ bgcolor: '#F8F8F8', minWidth: '85px' }}>In Stock</TableCell>
                                                        <TableCell sx={{ bgcolor: '#F8F8F8', width: '120px' }}>Quantity</TableCell>
                                                        <TableCell sx={{ bgcolor: '#F8F8F8', width: '120px' }}>Cost</TableCell>

                                                        <TableCell sx={{ bgcolor: '#F8F8F8' }}></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {inventoryLoader && <TableRowsLoader rowsNum={10} />}
                                                    {rows?.length > 0 &&
                                                        rows.map((row) => (
                                                            <TableRow key={row._id} hover>
                                                                <TableCell style={{ padding: '0' }}>
                                                                    <Checkbox
                                                                        checked={selectedInventory?.some((selectedItem) => selectedItem?._id === row._id)}
                                                                        onChange={() => handleCheckboxChange(row)}
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ width: '290px' }}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        style={{
                                                                            whiteSpace: 'pre-line',
                                                                            fontSize: '16px',
                                                                            letterSpacing: '0.15px',
                                                                            fontWeight: 500,
                                                                        }}
                                                                    >
                                                                        {row?.part?.partName}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="body2"
                                                                        style={{
                                                                            whiteSpace: 'pre-line',
                                                                            fontSize: '14px',
                                                                            letterSpacing: '0.17px',
                                                                            fontWeight: 400,
                                                                        }}
                                                                    >
                                                                        {row?.partNumber || row?.tyreDimension}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {row?.supplier?.name && (
                                                                        <Typography
                                                                            padding={0}
                                                                            sx={{
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                letterSpacing: '0.17px',
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                marginBottom: '4px',
                                                                            }}
                                                                            lineHeight={'normal'}
                                                                        >
                                                                            <SupplierIconSvg />

                                                                            {row.supplier.name}
                                                                        </Typography>
                                                                    )}
                                                                    {row?.partsBrand?.name && (
                                                                        <Typography
                                                                            padding={0}
                                                                            sx={{
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                letterSpacing: '0.17px',
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                marginBottom: '4px',
                                                                            }}
                                                                            lineHeight={'normal'}
                                                                        >
                                                                            <BrandSvg />
                                                                            {row.partsBrand.name}
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>{row.inStock}</TableCell>
                                                                <TableCell>
                                                                    <InputWithIcon
                                                                        value={row.partQty}
                                                                        borderRadius={'4px'}
                                                                        // disabled={
                                                                        //   !editableRows.includes(row._id)
                                                                        // }
                                                                        onChange={(numericValue) => {
                                                                            if (row.inStock < numericValue) {
                                                                                toast.error(`Not enough quantity in inventory.`);
                                                                                return;
                                                                            }

                                                                            handleInputChange(row._id, 'partQty', Number(numericValue));
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        value={row.partCost}
                                                                        // disabled={
                                                                        //   !editableRows.includes(row._id)
                                                                        // }
                                                                        onChange={(e) => {
                                                                            let inputValue = e.target.value;
                                                                            if (/^\d*\.?\d*$/.test(inputValue)) {
                                                                                handleInputChange(row._id, 'partCost', inputValue);
                                                                            }
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: <p style={{}}>$</p>,
                                                                        }}
                                                                        sx={{
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '0 12px 0 0 ',
                                                                                height: '40px',
                                                                            },
                                                                            '& .MuiInputBase-root': {
                                                                                height: '40px',
                                                                                borderRadius: '4px',
                                                                            },
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                {/* <TableCell style={{ paddingLeft: '0' }}>
                                                                    <Stack direction={'row'} gap={'8px'} alignItems={'center'}>
                                                                        {showEditInListing && (
                                                                            <IconButton onClick={() => {}}>
                                                                                <Edit
                                                                                    style={{
                                                                                        fontSize: 24,
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        )}
                                                                    </Stack>
                                                                </TableCell> */}
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </div>
                            </Grid>
                        )}
                    </DialogContent>

                    {/* Dialog Actions */}
                    <DialogActions sx={{ padding: '0!important' }}>
                        {!updateInventoryLoader && (
                            <Grid item container gap={2} justifyContent={'space-between'} padding={'16px'} borderTop={'1px solid rgba(0, 0, 0, 0.12)'}>
                                <Grid item>
                                    <Stack spacing={2} direction={'row'}>
                                        {isAdditionalVisible && isFeeVisible && editModalTabvalue === 1 && <></>}
                                        {!viewOnly && editModalTabvalue === 0 && (
                                            <Button
                                                variant="contained"
                                                color="greyColor"
                                                startIcon={
                                                    isAdditionalVisible ? (
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M2.5 15.25L10 7.75L17.5 15.25L19 13.75L10 4.75L1 13.75L2.5 15.25Z" fill="#212121" />
                                                        </svg>
                                                    ) : (
                                                        <Add />
                                                    )
                                                }
                                                sx={{
                                                    boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    '&:hover': {
                                                        boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    },
                                                }}
                                                size="large"
                                                onClick={() => setIsAdditionalVisible(!isAdditionalVisible)}
                                            >
                                                {isAdditionalVisible ? 'Collapse ADDITIONAL DETAILS' : ' Add Additional Details'}
                                            </Button>
                                        )}

                                        {!viewOnly && !isFeeVisible && editModalTabvalue === 0 && (
                                            <Button
                                                variant="contained"
                                                color="greyColor"
                                                startIcon={<Add />}
                                                sx={{
                                                    boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    '&:hover': {
                                                        boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                    },
                                                }}
                                                onClick={() => {
                                                    setIsFeeVisible(true);
                                                    setTimeout(() => {
                                                        if (dialogContentRef.current) {
                                                            dialogContentRef.current.scrollTo({
                                                                top: dialogContentRef.current.scrollHeight,
                                                                behavior: 'smooth', // Optional for smooth scroll
                                                            });
                                                        }
                                                    }, 300);
                                                }}
                                                size="large"
                                            >
                                                Add Fee
                                            </Button>
                                        )}
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Stack spacing={2} direction="row">
                                        {viewOnly && getValues().supplierId && getValues().supplierInvoiceNumber && (
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => {
                                                    if (getValues()?.supplierId) {
                                                        navigate(`/suppliers/${getValues().supplierId}`);
                                                    } else {
                                                        navigate('/suppliers/');
                                                    }
                                                }}
                                                size="large"
                                            >
                                                view Supplier
                                            </Button>
                                        )}
                                        {viewOnly && type === INVENTORY_TYPES.SUPPLIER_INVOICE && (
                                            <>
                                                {isUsedInCustomerInvoice ? (
                                                    <HtmlTooltip
                                                        title={
                                                            <React.Fragment>
                                                                <span>This part is connected with a customer invoice and not editable.</span>

                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{
                                                                        textTransform: 'uppercase',
                                                                        fontSize: 12,
                                                                        marginTop: 11,
                                                                        height: '28px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        padding: '0 8px',
                                                                    }}
                                                                    onClick={() => {
                                                                        setPartInvoiceModal(true);
                                                                    }}
                                                                >
                                                                    View Customer Invoice
                                                                </Button>
                                                            </React.Fragment>
                                                        }
                                                        placement="bottom"
                                                        arrow
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            disabled={true}
                                                            color="primary"
                                                            onClick={() => {
                                                                navigate(``);
                                                            }}
                                                            size="large"
                                                        >
                                                            Edit {togglePartType === PART_TYPES.TIRE ? 'Tire' : 'Part'}
                                                        </Button>
                                                    </HtmlTooltip>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            if (supplierInvoiceId) {
                                                                navigate(`/suppliers-invoice/${supplierInvoiceId}?batch=${batchNumber}`);
                                                            }
                                                        }}
                                                        size="large"
                                                    >
                                                        Edit {togglePartType === PART_TYPES.TIRE ? 'Tire' : 'Part'}
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                        {!viewOnly && (
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                disabled={showLoader}
                                                onClick={() => {
                                                    if (!showLoader) {
                                                        if (isAddPartBtn) {
                                                            setIsAddPartAgain(false);
                                                        }
                                                        handleClose();
                                                        // onSubmitModal();
                                                    }
                                                }}
                                                size="large"
                                            >
                                                Cancel
                                            </Button>
                                        )}
                                        {isAddPartBtn && !inventoryId && editModalTabvalue === 0 && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                type="submit"
                                                disabled={showLoader || updateInventoryLoader}
                                                onClick={() => {
                                                    if (!showLoader) {
                                                        if (isAddPartBtn) {
                                                            setIsAddPartAgain(true);
                                                        }
                                                    }
                                                }}
                                            >
                                                Save & add another
                                            </Button>
                                        )}
                                        {!viewOnly && editModalTabvalue === 0 ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                type="submit"
                                                disabled={showLoader || updateInventoryLoader}
                                                onClick={() => {
                                                    if (!showLoader) {
                                                        if (isAddPartBtn) {
                                                            setIsAddPartAgain(false);
                                                        }
                                                    }
                                                }}
                                            >
                                                {type === INVENTORY_TYPES.SUPPLIER_INVOICE && batchNumber
                                                    ? 'Update Invoice'
                                                    : type === INVENTORY_TYPES.SUPPLIER_INVOICE || type === INVENTORY_TYPES.INVOICE
                                                      ? !inventoryId && !singleInventoryId
                                                          ? 'Add to Invoice'
                                                          : 'Save Changes'
                                                      : togglePartType === PART_TYPES.PARTS
                                                        ? 'Save Part'
                                                        : 'Save Tire'}
                                            </Button>
                                        ) : !viewOnly ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                disabled={showLoader || updateInventoryLoader}
                                                onClick={() => {
                                                    if (!showLoader) {
                                                        if (isAddPartBtn) {
                                                            setIsAddPartAgain(false);
                                                        }
                                                        handleClose();
                                                        onSubmitModal();
                                                    }
                                                }}
                                            >
                                                {type === INVENTORY_TYPES.INVOICE
                                                    ? 'Add to Invoice'
                                                    : togglePartType === PART_TYPES.PARTS
                                                      ? 'Save Part'
                                                      : 'Save Tire'}
                                            </Button>
                                        ) : (
                                            <></>
                                        )}
                                    </Stack>
                                </Grid>
                            </Grid>
                        )}
                    </DialogActions>
                </form>
            </Dialog>

            <AddQuickSupplierModal
                openModal={openAddSupplierModal}
                supplierName={supplierName}
                onClose={() => {
                    setSupplierName('');
                    setOpenAddSupplierModal(false);
                }}
                onSave={(resp) => {
                    if (resp?._id) {
                        fetchSupplierList('');
                        setSupplierInput(resp?.name);
                        setValue('supplierId', resp?._id);
                        clearErrors('supplierId');
                        setSupplierName('');
                        setOpenAddSupplierModal(false);
                    }
                }}
            />

            {inventoryCase === INVETORY_CASE.CASE_1 && (
                <CommonDialog
                    open={openConflictModal}
                    dialogClaassName={'commonDialog commonDialog__560'}
                    dialogTitle={'Change Part Price or Create New'}
                    dialogSubtitle={`A part with the same name and number already exists, but with a different cost.`}
                    dialogSubtitle2={'Would you like to update the existing part’s cost or create a new part with this price?'}
                    buttonPadding={'16px 0 0 0'}
                    saveButtonText={'Edit Existing Part'}
                    saveButtonWidth={'197px'}
                    saveButtonType={'primary'}
                    confirmButtonText={'Create New Part'}
                    confirmButtonWidth={'182px'}
                    confirmButtonType={'secondary'}
                    onClose={() => {
                        setOpenConflictModal(false);
                    }}
                    onSave={() => {
                        setShowLoader(true);
                        setOpenConflictModal(false);
                        onSubmit(getValues(), true, 'update_existing_part');
                    }}
                    onConfirm={() => {
                        setShowLoader(true);
                        setOpenConflictModal(false);
                        onSubmit(getValues(), true, 'create_new_part');
                    }}
                />
            )}

            {inventoryCase === INVETORY_CASE.CASE_2 && (
                <CommonDialog
                    open={openConflictModal}
                    dialogTitle={'Update Cost for Existing Part?'}
                    dialogSubtitle={`A part with the same name and number already exists on this supplier invoice, but with a different cost. Updating the cost will change the cost for all quantities of this part on the invoice. `}
                    dialogSubtitle2={'Do you want to continue?'}
                    buttonPadding={'16px 0 0 0'}
                    cancelButtonText={'cancel'}
                    saveButtonText={'Update Cost'}
                    saveButtonWidth={'147px'}
                    saveButtonType={'primary'}
                    onClose={() => {
                        setOpenConflictModal(false);
                    }}
                    onSave={(conflictResolution) => {
                        setShowLoader(true);
                        setOpenConflictModal(false);
                        onSubmit(getValues(), true, 'update_cost');
                    }}
                />
            )}
            <PartUsedInvoiceModal
                open={partInvoiceModal}
                batchNumber={batchNumber}
                onClose={() => {
                    setPartInvoiceModal(false);
                }}
            />
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
        </>
    );
};
export default AddInventoryModal;
